<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">
        Tender Details
      </h2>
    </div>
    <div class="grid grid-cols-12 mt-5">
      <div class="intro-y col-span-12 lg:col-span-12">
        <!-- BEGIN: Input -->
        <div class="intro-y box">
          <div class="p-5">
            <div class="grid grid-cols-12 gap-x-5">
              <div class="col-span-12 lg:col-span-5">
                <div>
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Tender Name :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{ page_data.tenderDetail.tender_name }}</label
                  >
                </div>
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Company Name :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{
                      page_data.tenderDetail.tender_company?.firm_name
                    }}</label
                  >
                </div>
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Tender Date :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{ page_data.tenderDetail.tender_date }}
                  </label>
                </div>
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Declare Date :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{ page_data.tenderDetail.declare_date }}</label
                  >
                </div>

                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Tender Place :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{ page_data.tenderDetail.location?.location_name }}</label
                  >
                </div>
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Partner :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{ page_data.tenderDetail.partner?.firm_name }}</label
                  >
                </div>
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Partnership(%) :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{ page_data.tenderDetail.partnership }}</label
                  >
                </div>

                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText == 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Status :&nbsp;</label
                  >
                  <span
                    class="text-xs font-medium me-2 px-2.5 py-0.5 rounded"
                    :class="
                      page_data.tenderDetail.statusText == 'Cancelled'
                        ? 'bg-red-100 text-red-800'
                        : page_data.tenderDetail.statusText == 'Won'
                        ? 'bg-blue-100 text-blue-800'
                        : page_data.tenderDetail.statusText == 'Active'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    "
                    >{{ page_data.tenderDetail.statusText }}</span
                  >
                </div>
                <div class="mt-2" v-if="page_data.tenderDetail.statusText == 'Won'">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Expense File:&nbsp;</label><label for="update-profile-form-6" class="form-label">
                    <a
                      target="_blank"
                      :href="baseURL + page_data.tenderDetail.expense_file"
                      >Excel</a
                    ></label
                  >
                </div>
                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText == 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Finance Company :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{
                      page_data.tenderDetail?.tender_winning
                        ?.finance_company_detail?.firm_name
                    }}</label
                  >
                </div>
              </div>
              <div class="col-span-12 lg:col-span-5">
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Total Lots :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{ page_data.tenderDetail.total_lots }}</label
                  >
                </div>
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Total Weight :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{ page_data.tenderDetail.total_weight }}</label
                  >
                </div>
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Total Amount :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{
                      page_data.tenderDetail.total_amount
                        ? page_data.tenderDetail.total_amount
                        : 0
                    }}</label
                  >
                </div>
                <div class="mt-2">
                  <label for="update-profile-form-6" class="form-label font-bold">
                    Lot List File:&nbsp;</label><label for="update-profile-form-6" class="form-label">
                    <a
                      v-if="page_data.tenderDetail.lotlist_file"
                      target="_blank"
                      :href="baseURL + page_data.tenderDetail.lotlist_file"
                      >Click to download</a
                    >
                    <span v-else>No lot list file uploaded</span>
                    </label
                  >
                </div>
                <div class="mt-2">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Total Expense :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    <a
                      href="javascript:;"
                      data-toggle="modal"
                      data-target="#expense-detail-modal"
                      >{{ page_data.tenderDetail.total_expense }}</a
                    ></label
                  >
                </div>
                <div
                  class="mt-2" v-if="page_data.tenderDetail.statusText != 'Won'">
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Expense File:&nbsp;</label>
                  <label for="update-profile-form-6" class="form-label">
                    <a
                      target="_blank"
                      :href="baseURL + page_data.tenderDetail.expense_file"
                      >Excel</a
                    ></label
                  >
                </div>
                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText != 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Status :&nbsp;</label
                  >
                  <span
                    class="text-xs font-medium me-2 px-2.5 py-0.5 rounded"
                    :class="
                      page_data.tenderDetail.statusText == 'Cancelled'
                        ? 'bg-red-100 text-red-800'
                        : page_data.tenderDetail.statusText == 'Won'
                        ? 'bg-blue-100 text-blue-800'
                        : page_data.tenderDetail.statusText == 'Active'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    "
                    >{{ page_data.tenderDetail.statusText }}</span
                  >
                </div>
                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText == 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Win. Packets :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{
                      page_data.tenderDetail?.tender_winning?.lot_items.length
                    }}</label
                  >
                </div>
                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText == 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Win. Weight :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{
                      page_data.tenderDetail?.tender_winning?.total_weight
                    }}</label
                  >
                </div>
                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText == 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Win. Per/Ct :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{
                      page_data.tenderDetail?.tender_winning?.per_ct_price
                    }}</label
                  >
                </div>
                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText == 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Total Price :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    {{
                      page_data.tenderDetail?.tender_winning?.total_amount
                    }}</label
                  >
                </div>
                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText == 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Import Expenses :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    <a
                      href="javascript:;"
                      data-toggle="modal"
                      data-target="#import-detail-modal"
                      >{{ page_data.tenderDetail?.total_expense }}</a
                    ></label
                  >
                </div>
                <div
                  class="mt-2"
                  v-if="page_data.tenderDetail.statusText == 'Won'"
                >
                  <label
                    for="update-profile-form-6"
                    class="form-label font-bold"
                    >Finance Expenses :&nbsp;</label
                  ><label for="update-profile-form-6" class="form-label">
                    <a
                      href="javascript:;"
                      data-toggle="modal"
                      data-target="#finance-detail-modal"
                      >{{ page_data.finance_expenses ?? 0 }}</a
                    ></label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="intro-y box my-5 py-5">
          <div class="col-span-12 xl:col-span-12">
            <div
              class="flex items-center justify-between pt-2 p-5 border-b border-gray-200 dark:border-dark-5"
            >
            <div>
              <h2 class="font-medium text-base mr-auto pl-5">Lot Details</h2>
            </div>
            <div>
              <button
                v-if="page_data.tenderDetail.type === 'Single'"
                type="button"
                class="btn btn-primary p-1 rounded-sm text-right mx-2 h-9"
                @click="openNewLotPlan"
              >Add Plan</button>
              <a
                class="btn btn-success p-1 rounded-sm text-right mx-2 h-9"
                @click="exportReportDetails"
                >Export Lot</a>
              <button
                type="button"
                id="btn_expplan"
                class="btn btn-danger p-1 rounded-sm text-right mx-2 inline-flex items-center justify-center h-9"
                :class="{ 'opacity-50 cursor-not-allowed': page_data.exportingPlan }"
                :disabled="page_data.exportingPlan"
                @click="exportReportPlanDetails"
              >
                <span class="inline-flex items-center justify-center">
                  <span v-if="page_data.exportingPlan" class="inline-flex items-center">
                    Exporting
                    <LoadingIcon icon="oval" color="white" class="w-4 h-4 ml-2" />
                  </span>
                  <span v-else>Export Plan</span>
                </span>
              </button>
              <a
                class="btn btn-primary p-1 rounded-sm text-right mx-2 h-9"
                @click="printReportDetails"
                >Print</a
              >
            </div>
            </div>
            <div class="m-5">
              <div class="border">
                <div class="overflow-x-auto">
                  <table class="w-full text-center text-xs">
                    <thead>
                      <tr class="bg-theme-14">
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Lot. No
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Weight
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Result
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Color
                        </th>
                        <!-- <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Purity
                        </th> -->
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Blue UV
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Brown
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Comment
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Flow
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Tension
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Eyeclc-R
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Eyeclc-F
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Center
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Per/Ct ($)
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Final Price ($)
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Total Plans
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Video
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Cap
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Image
                        </th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Status
                        </th>
                        <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Final</th>
                        <th
                          class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                        >
                          Plan
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      class="text-center"
                      v-for="(field, index) in page_data.tenderDetail.lot_items"
                      :key="index"
                    >
                      <tr
                        class="hover:bg-gray-200"
                        :class="{ 'bg-gray-100': index % 2 == 0 }"
                      >
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          <button
                            v-if="field.active_status === 1"
                            type="button"
                            class="text-primary-1 hover:underline focus:underline"
                            :aria-label="'Open planning for lot ' + field.lot_no"
                            @click="new_planning(field)"
                          >
                            {{ field.lot_no }}
                          </button>
                          <span v-else>{{ field.lot_no }}</span>
                          <br>
                          <!-- {{ console.log('--',field.tender_winlot_items) }} -->
                          <!-- <pre>{{ field.tender_winlot_items[0]?.lot_id }}</pre> -->
                          <!-- {{ page_data.tenderDetail.tender_winning.lot_items[0].lot_id == field.id ? `(${page_data.tenderDetail.tender_winning.lot_items[0].kapanno})` : '' }} -->
                              {{ field.tender_winlot_items ? field.tender_winlot_items[0]?.lot_id == field.id ? `(${field.tender_winlot_items[0]?.kapanno?field.tender_winlot_items[0]?.kapanno:''})` : ''  : ''}}
                                <!-- {{ field.tender_winlot_items ? field.tender_winlot_items[0].lot_id == field.id ? '--' : '=='  : '---'}} -->
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{ field.weight }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.result_item
                              ? field.result_item.color_name
                              : field.result == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.color_item
                              ? field.color_item.color_name
                              : field.color == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <!-- <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.purity_item
                              ? field.purity_item.purity_name
                              : field.purity == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td> -->
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{ field.blue_uv }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.brown_item
                              ? field.brown_item.brown_name
                              : field.brown == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.comment_item
                              ? field.comment_item.comment_name
                              : field.comment == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.flow_item
                              ? field.flow_item.fluerocent_name
                              : field.flow == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.tension_item
                              ? field.tension_item.tension_name
                              : field.tension == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.eyeclc_r_item
                              ? field.eyeclc_r_item.color_name
                              : field.eyeclc_r == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.eyeclc_f_item
                              ? field.eyeclc_f_item.color_name
                              : field.eyeclc_f == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            field.center_item
                              ? field.center_item.purity_name
                              : field.center == 'no_result'
                              ? '???'
                              : '-'
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{ finalLotPrice(field, 'per_ct') }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{
                            finalLotPrice(field, 'tender_amount')
                          }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                          {{ field.tender_plans ? field.tender_plans.length : 0 }}
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                        <div v-if="field.video">
                          <a target="_blank" class="text-primary-4" :href="baseURL + field.video"
                            ><VideoIcon class="h-5 w-5" /></a
                          >
                        </div>
                        <div class="text-primary-3" v-else>
                          <VideoOffIcon class="h-5 w-5" />
                        </div>
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                        <div v-if="field.cap">
                          <a target="_blank" class="text-primary-4" :href="baseURL + field.cap"
                            ><EyeIcon class="h-5 w-5" /></a
                          >
                        </div>
                        <div class="text-primary-3" v-else>
                          <EyeOffIcon class="h-5 w-5" />
                        </div>
                        </td>
                        <td
                          class="border-b border-r py-2 px-2 whitespace-nowrap"
                        >
                        <div v-if="field.image">
                          <a target="_blank" class="text-primary-4" :href="baseURL + field.image"
                            ><CameraIcon class="h-5 w-5" /></a
                          >
                        </div>
                        <div class="text-primary-3" v-else>
                          <CameraOffIcon class="h-5 w-5" />
                        </div>
                        </td>
                        <td class="border-b border-r py-2 px-2 whitespace-nowrap">
                          <span
                            class="text-xs font-medium me-2 px-2.5 py-0.5 rounded"
                            :class="{
                              'bg-red-100 text-red-800':
                                field.active_status === 3 ||
                                (field.active_status !== 1 &&
                                  field.active_status !== 2),
                              'bg-blue-100 text-blue-800':
                                field.active_status === 2,
                              'bg-green-100 text-green-800':
                                field.active_status === 1
                            }"
                          >
                            {{
                              field.active_status === 1
                                ? 'Active'
                                : field.active_status === 2
                                ? 'Won'
                                : field.active_status === 3
                                ? 'Cancelled'
                                : 'Expired'
                            }}
                          </span>
                        </td>

                        <td class="border-b border-r py-2 px-2 whitespace-nowrap text-center"><span :class="hasFinalPlan(field) ? 'text-green-800' : 'text-red-800'" class="text-lg font-bold" :title="hasFinalPlan(field) ? 'Final plan selected' : 'No Final plan'">{{ hasFinalPlan(field) ? '✓' : '✗' }}</span></td>
                        <td class="border-b border-r py-2 px-2 whitespace-nowrap">
                          <a class="text-primary-1" href="javascript:;" @click="new_planning(field)" v-if="field.active_status === 1">
                            <span
                              class="text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-blue-100 text-blue-800"
                            >
                              New Plan
                            </span></a
                          >
                          <a class="text-primary-4 ml-2" href="javascript:;"
                          data-toggle="modal"
                          data-target="#view-manual-planning" @click="view_planning(field)">
                            <span
                              class="text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-green-100 text-green-800"
                            >
                              View Plan
                            </span></a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div
                    class="text-center py-2"
                    v-if="page_data.tenderDetail.lot_items.length == 0"
                  >
                    Records not Found
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="expense-detail-modal"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <a data-dismiss="modal" href="javascript:;">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">Expense Detail</h2>
          </div>
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <div class="m-5">
                <div class="border">
                  <div class="overflow-x-auto">
                    <table class="w-full text-center text-xs">
                      <thead>
                        <tr class="bg-theme-14">
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Sr. No
                          </th>
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Expense Name
                          </th>
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Amount
                          </th>
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            File
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        class="text-center"
                        v-for="(field, index) in page_data.tenderDetail
                          .expense_items"
                        :key="index"
                      >
                        <tr
                          class="hover:bg-gray-200"
                          :class="{ 'bg-gray-100': index % 2 == 0 }"
                        >
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ index + 1 }}
                          </td>
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ field.expense?.expense_name }}
                          </td>
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ field.amount }}
                          </td>
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            <a target="_blank" :href="baseURL + field.file"
                              >File</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div
                    class="text-center py-2"
                    v-if="page_data.tenderDetail.lot_items.length == 0"
                  >
                    Records not Found
                  </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="import-detail-modal"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <a data-dismiss="modal" href="javascript:;">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">
              Import Expenses Detail
            </h2>
          </div>
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <div class="m-5">
                <div class="border">
                  <div class="overflow-x-auto">
                    <table class="w-full text-center text-xs">
                      <thead>
                        <tr class="bg-theme-14">
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Sr. No
                          </th>
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Expense Name
                          </th>
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        class="text-center"
                        v-for="(field, index) in page_data.tenderDetail
                          ?.tender_winning?.import_expense_items"
                        :key="index"
                      >
                        <tr
                          class="hover:bg-gray-200"
                          :class="{ 'bg-gray-100': index % 2 == 0 }"
                        >
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ index + 1 }}
                          </td>
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ field.expense?.expense_name }}
                          </td>
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ field.amount }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div
                    class="text-center py-2"
                    v-if="page_data.tenderDetail.lot_items.length == 0"
                  >
                    Records not Found
                  </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="finance-detail-modal"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <a data-dismiss="modal" href="javascript:;">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">
              Finance Expenses Detail
            </h2>
          </div>
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <div class="m-5">
                <div class="border">
                  <div class="overflow-x-auto">
                    <table class="w-full text-center text-xs">
                      <thead>
                        <tr class="bg-theme-14">
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Sr. No
                          </th>
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Expense Name
                          </th>
                          <th
                            class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5"
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        class="text-center"
                        v-for="(field, index) in page_data.tenderDetail
                          ?.tender_winning?.finance_expense_items"
                        :key="index"
                      >
                        <tr
                          class="hover:bg-gray-200"
                          :class="{ 'bg-gray-100': index % 2 == 0 }"
                        >
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ index + 1 }}
                          </td>
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ field.expense?.expense_name }}
                          </td>
                          <td
                            class="border-b border-r py-2 px-2 whitespace-nowrap"
                          >
                            {{ field.amount }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div
                    class="text-center py-2"
                    v-if="page_data.tenderDetail.lot_items.length == 0"
                  >
                    Records not Found
                  </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="new-manual-planning"
      ref="new-manual-planning"
      class="modal tender-plan-ui"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl plan-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="flex justify-between items-center w-full">
              <h2 class="font-medium text-base mr-auto">
                New Planning (Lot No: {{ planLot.lot_no || '-' }}) (Weight
                {{ planLot.weight || 0 }} Ct)
              </h2>
              <a data-dismiss="modal" href="javascript:;">
                <XIcon class="w-8 h-8 text-gray-500" />
              </a>
            </div>
            <div class="plan-sticky-context">
            <div class="plan-top">
              <div class="plan-field">
                <label>Tender Name</label
                ><input v-model="page_data.tenderDetail.tender_name" type="text" class="form-control" readonly />
              </div>
              <div class="plan-field">
                <label>Lot #</label
                ><input
                  v-model="planLot.lot_no"
                  @change="resolveExistingPlanLot"
                  :readonly="!!page_data.planning_packet.id"
                  type="text"
                  inputmode="numeric"
                  placeholder="Enter Lot Number"
                  class="form-control"
                />
              </div>
              <div class="plan-field">
                <label>Rough Weight</label
                ><input
                  v-model="planLot.weight"
                  type="number"
                  class="form-control"
                  min="0"
                  step="0.01"
                  :readonly="page_data.tenderDetail.type !== 'Single' &amp;&amp; !planLot.is_new"
                />
              </div>
              <div class="plan-field">
                <label>Less %</label><input v-model="planLot.less" type="number" class="form-control" />
              </div>
              <div class="plan-field">
                <label>Reserve Price</label><input v-model="planLot.reserve_price" type="number" class="form-control" />
              </div>
              <div class="plan-field">
                <label>Result</label>
                <select v-model="planLot.result" class="form-select">
                  <option value="no_result">???</option>
                  <option v-for="item in diamond.colors" :key="item.id" :value="item.id">{{ item.color_name }}</option>
                </select>
              </div>
              <div class="plan-field">
                <label>Color</label>
                <select v-model="planLot.color" class="form-select">
                  <option value="no_result">??</option>
                  <option v-for="item in diamond.colors" :key="item.id" :value="item.id">{{ item.color_name }}</option>
                </select>
              </div>
              <div class="plan-field">
                <label>Blue UV</label>
                <select v-model="planLot.blue_uv" class="form-select">
                  <option value="">Select</option>
                  <option v-for="value in Array.from({ length: 76 }, (_, i) => String(i).padStart(3, '0'))" :key="value" :value="value">{{ value }}</option>
                </select>
              </div>
              <div class="plan-field">
                <label>Final PPC</label><input v-model="planLot.final_ppc" type="text" class="form-control" readonly />
              </div>
              <div class="plan-field">
                <label>Final Total (RW)</label
                ><input v-model="planLot.final_total" type="text" class="form-control" readonly />
              </div>
            </div>
            <div class="plan-media-actions">
              <div class="plan-media">
                <div v-for="kind in ['video', 'cap', 'image']" :key="kind">
                  <label>{{ kind }}:</label>
                  <button type="button" class="btn btn-outline-primary plan-media-upload" :disabled="planMediaBusy" :title="'Upload or change ' + kind" :aria-label="'Upload or change ' + kind" @click.stop.prevent="$event.currentTarget.nextElementSibling.click()">
                    <UploadIcon class="w-4 h-4" />
                  </button>
                  <!-- Leave accept unset: all three slots support any file, including .cap. -->
                  <input type="file" class="hidden" :disabled="planMediaBusy" :aria-label="'Choose any file for ' + kind" @change="uploadPlanMedia(kind, $event)" />
                  <a v-if="planLot[kind]" :href="mediaUrl(planLot[kind])" :download="canOpenMedia(planLot[kind]) ? null : ''" :target="canOpenMedia(planLot[kind]) ? '_blank' : null" rel="noopener noreferrer" class="btn btn-outline-primary plan-media-open" :title="(canOpenMedia(planLot[kind]) ? 'Open current ' : 'Download current ') + kind" :aria-label="(canOpenMedia(planLot[kind]) ? 'Open current ' : 'Download current ') + kind"><ImageIcon class="w-4 h-4" /></a>
                </div>
              </div>
              <div class="flex gap-2">
                <button type="button" class="btn btn-outline-primary" :disabled="page_data.loading" @click="newPlanLot">New Lot</button
                ><button type="button" class="btn btn-outline-primary" :disabled="page_data.loading" @click="startNewPlan">New Plan</button
                ><button
                  type="button"
                  class="btn btn-primary"
                  :disabled="page_data.loading || planMediaBusy"
                  @click="stagePlanPart"
                >
                  New Tag
                </button>
              </div>
              <div class="plan-lot-options">
                <div class="plan-field plan-field-narrow">
                  <label>Machine Comment</label
                  ><select v-model="planLot.comment" class="form-select"
                    ><option value="">Select</option
                    ><option v-for="item in diamond.comments" :key="item.id" :value="item.id">{{
                      item.comment_name
                    }}</option></select
                  >
                </div>
                <div class="plan-field plan-field-compact">
                  <label>Tension</label
                  ><select v-model="planLot.tension" class="form-select"
                    ><option value="">Select</option
                    ><option v-for="item in diamond.tensions" :key="item.id" :value="item.id">{{
                      item.tension_name
                    }}</option></select
                  >
                </div>
              </div>
            </div>
            </div>
          </div>
          <div class="modal-body">
            <div v-if="!planningParamsReady" class="p-4 mb-4 border rounded" role="status">
              <span v-if="planningParamsLoading">Loading planning options…</span>
              <template v-else>
                <span>{{ planningParamsError || 'Planning options are not loaded yet.' }}</span>
                <button type="button" class="btn btn-outline-primary ml-3" @click="get_params">Retry</button>
              </template>
            </div>
            <section v-for="plan in (planningParamsReady ? [partEntry] : [])" :key="plan.id" class="plan-entry">
              <div class="plan-pricing">
                <div class="plan-field">
                  <label>Plan No</label><input v-model="plan.part_no" type="text" class="form-control" @input="selectPlanSummary()" />
                </div>
                <div class="plan-field">
                  <label>Polish Weight</label
                  ><input
                    v-model="plan.polish_weight"
                    type="number"
                    class="form-control"
                    min="0"
                    step="0.001"
                    @change="loadPlanningValues(plan, 'repo')"
                  />
                </div>
                <div class="plan-field">
                  <div class="plan-repo-heading">
                    <label>Repo Rate</label>
                    <button
                      v-for="size in [5, 10]"
                      :key="size"
                      type="button"
                      class="btn btn-sm plan-size-control"
                      :class="plan.size == size ? 'btn-primary' : 'btn-outline-primary'"
                      :disabled="plan.polish_weight &lt; 10"
                      @click="updateSize(size, plan)"
                    >
                      +{{ size }}
                    </button>
                  </div>
                  <input v-model="plan.r_rate" readonly class="form-control plan-repo-rate-input" />
                </div>
                <div class="plan-field">
                  <label>Disc (%)</label>
                  <input v-model="plan.discount" type="number" step="0.01" class="form-control" @input="updatePlanDiscount(plan)" />
                </div>
                <div class="plan-field">
                  <label>PPC</label><input v-model="plan.per_ct" type="text" class="form-control" readonly />
                </div>
                <div class="plan-field">
                  <label>Total</label><input v-model="plan.value" type="text" class="form-control" readonly />
                </div>
                <div class="plan-field">
                  <label>BID PPC (RW)</label><input v-model="plan.bid_ppc" type="text" class="form-control" readonly />
                </div>
                <div class="plan-field">
                  <label>Less %</label><input v-model="plan.bid_less" @input="partLessOverridden = true" type="number" min="0" max="100" step="0.01" class="form-control" />
                </div>
                <div class="plan-field">
                  <label>BID Final Total (RW)</label
                  ><input v-model="plan.bid_final_total" type="text" class="form-control" readonly />
                </div>
              </div>
              <div class="plan-adjacent">
                <div class="plan-field">
                  <label>Color UP</label><input v-model="plan.color_up" type="text" class="form-control" readonly />
                </div>
                <div class="plan-field">
                  <label>Color Down</label><input v-model="plan.color_down" type="text" class="form-control" readonly />
                </div>
                <div class="plan-field">
                  <label>Purity UP</label><input v-model="plan.purity_up" type="text" class="form-control" readonly />
                </div>
                <div class="plan-field">
                  <label>Purity Down</label
                  ><input v-model="plan.purity_down" type="text" class="form-control" readonly />
                </div>
              </div>
              <parameter-options
                title="Shape"
                field="shape"
                label-field="shape_name"
                :items="diamond.shapes"
                :row="plan"
                @change="selectPlanParameter(plan, 'shape', $event, 'repo')"
              /><parameter-options
                title="Color"
                field="color"
                label-field="color_name"
                :items="diamond.colors"
                :row="plan"
                @change="selectPlanParameter(plan, 'color', $event, 'repo')"
              /><parameter-options
                title="Purity"
                field="purity"
                label-field="purity_name"
                :items="diamond.purities"
                :row="plan"
                @change="selectPlanParameter(plan, 'purity', $event, 'repo')"
              />
              <div class="plan-pair">
                <parameter-options
                title="Cut"
                field="cut"
                label-field="cut_name"
                :items="diamond.cuts"
                :row="plan"
                @change="selectPlanParameter(plan, 'cut', $event, 'cut')"
              />
                <parameter-options
                  title="Polish"
                  field="polish"
                  label-field="polish_name"
                  :items="diamond.polish"
                  :row="plan"
                  @change="selectPlanParameter(plan, 'polish', $event, 'repo')"
                /><parameter-options
                  title="Symmetry"
                  field="symmetry"
                  label-field="symmetry_name"
                  :items="diamond.symmetry"
                  :row="plan"
                  @change="selectPlanParameter(plan, 'symmetry', $event, 'symmetry')"
                />
              </div>
              <div class="plan-pair plan-pair-two">
              <parameter-options
                title="Fluorescence"
                field="fluerocent"
                label-field="fluerocent_name"
                :items="diamond.fluerocents"
                :row="plan"
                @change="selectPlanParameter(plan, 'fluerocent', $event, 'fluerocent')"
              /><parameter-options
                title="Brown"
                field="brown"
                label-field="brown_name"
                :items="diamond.browns"
                :row="plan"
                @change="selectPlanParameter(plan, 'brown', $event, 'brown')"
              />
              </div>
              <div class="plan-additional">
                <div class="plan-field plan-field-remark">
                  <label>Remark</label><input v-model="plan.remark" type="text" class="form-control" />
                </div>
                <div class="plan-field plan-field-narrow">
                  <label>Inclusion Type</label
                  ><select
                    v-model="plan.inclusion_type"
                    class="form-select"
                    @change="loadPlanningValues(plan, 'inclusion_type')"
                    ><option value="">Select</option
                    ><option v-for="item in diamond.inclusion_types" :key="item.id" :value="item.id">{{
                      item.type
                    }}</option></select
                  >
                </div>
                <div class="plan-field plan-field-narrow">
                  <label>Diamond Type</label
                  ><select
                    v-model="plan.diamond_type"
                    class="form-select"
                    @change="loadPlanningValues(plan, 'diamond_type')"
                    ><option value="">Select</option
                    ><option v-for="item in diamond.diamond_types" :key="item.id" :value="item.id">{{
                      item.type
                    }}</option></select
                  >
                </div>
                <div class="plan-field plan-field-compact">
                  <label>Ratio</label
                  ><select v-model="plan.ratio" class="form-select" @change="loadPlanningValues(plan, 'repo')"
                    ><option value="">Select</option
                    ><option v-for="item in diamond.ratios" :key="item.id" :value="item.id">{{
                      item.ratio_name
                    }}</option></select
                  >
                </div>
                <div class="plan-field plan-field-compact">
                  <label>Table</label
                  ><select v-model="plan.tabl" class="form-select" @change="loadPlanningValues(plan, 'repo')"
                    ><option value="">Select</option
                    ><option v-for="item in diamond.tabls" :key="item.id" :value="item.id">{{
                      item.tabl_name
                    }}</option></select
                  >
                </div>
                <div class="plan-field plan-field-compact">
                  <label>Depth</label
                  ><select v-model="plan.height" class="form-select" @change="loadPlanningValues(plan, 'repo')"
                    ><option value="">Select</option
                    ><option v-for="item in diamond.heights" :key="item.id" :value="item.id">{{
                      item.height_name
                    }}</option></select
                  >
                </div>
              </div>
            </section>
            <div class="plan-draft-table mt-5 overflow-x-auto">
              <table class="table whitespace-nowrap">
                <thead><tr><th>Plan No</th><th>Part</th><th>Action</th><th>Color</th><th>Purity</th><th>Polish Weight</th><th>Polish (%)</th><th>Shape</th><th>Ratio</th><th>Flo</th><th>Repo Rate</th><th>Disc (%)</th><th>PPC</th><th>Total</th><th>BID PPC</th><th>Less %</th><th>BID Final Total</th><th>Final Total</th></tr></thead>
                <tbody>
                  <tr v-for="row in draftTableRows" :key="row.group.key + '-' + row.part.id" :class="row.planIndex % 2 === 0 ? 'plan-shade-light' : 'plan-shade-blue'">
                    <td v-if="row.planSpan" :rowspan="row.planSpan">
                      <button type="button" class="block mb-2 text-primary" @click="selectPlanSummary(row.group.parts[0]?.part_no)">{{ row.group.parts[0]?.part_no }}</button>
                      <button
                        v-if="row.group.id && (Number(draftPlanningLot.final_plan_id) === Number(row.group.id) || !hasFinalPlan(draftPlanningLot))"
                        type="button"
                        class="text-xs font-medium px-2.5 py-0.5 rounded"
                        :class="Number(draftPlanningLot.final_plan_id) === Number(row.group.id) ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'"
                        :disabled="finalPlanBusy || page_data.loading"
                        @click="toggleFinalPlan(row.group, draftPlanningLot)"
                      >{{ Number(draftPlanningLot.final_plan_id) === Number(row.group.id) ? 'Remove Final' : 'Final' }}</button>
                    </td>
                    <td>{{ row.index + 1 }}</td>
                    <td class="plan-action-cell"><button type="button" class="btn btn-sm btn-primary" @click="editDraftPart(row.group, row.index)">Edit</button></td>
                    <td>{{ draftLabel(diamond.colors, row.part.color, 'color_name') }}</td>
                    <td class="plan-purity-cell" :title="draftLabel(diamond.purities, row.part.purity, 'purity_name')"><span>{{ draftLabel(diamond.purities, row.part.purity, 'purity_name') }}</span></td>
                    <td class="plan-polish-weight">{{ formatPlanNumber(row.part.polish_weight, 3) }}</td>
                    <td v-if="row.planSpan" :rowspan="row.planSpan">{{ planPolishPercentage(row.group) }}</td>
                    <td>{{ draftLabel(diamond.shapes, row.part.shape, 'shape_name') }}</td>
                    <td>{{ draftLabel(diamond.ratios, row.part.ratio, 'ratio_name') }}</td>
                    <td>{{ draftLabel(diamond.fluerocents, row.part.fluerocent, 'fluerocent_name') }}</td>
                    <td>{{ row.part.r_rate }}</td>
                    <td>{{ row.part.discount }}</td>
                    <td>{{ formatPlanNumber(row.part.per_ct, 2) }}</td>
                    <td>{{ formatPlanCurrency(row.part.value) }}</td>
                    <td>{{ formatPlanNumber(row.part.bid_ppc, 2) }}</td>
                    <td>{{ row.part.bid_less }}</td>
                    <td>{{ formatPlanCurrency(row.part.bid_final_total) }}</td>
                    <td v-if="row.planSpan" :rowspan="row.planSpan" class="font-semibold">{{ formatPlanCurrency(row.group.parts.reduce((sum, part) => sum + Number(part.bid_final_total || 0), 0)) }}</td>
                  </tr>
                  <tr v-if="!draftTableRows.length"><td colspan="18" class="text-center"></td></tr>
                </tbody>
                <tfoot v-if="draftTableRows.length">
                  <tr class="plan-draft-total"><td colspan="5">Total</td><td>{{ draftTableTotals.weight.toFixed(3) }}</td><td colspan="7"></td><td>{{ formatPlanCurrency(draftTableTotals.value) }}</td><td colspan="2"></td><td>{{ formatPlanCurrency(draftTableTotals.bidFinalTotal) }}</td><td>{{ formatPlanCurrency(draftTableTotals.bidFinalTotal) }}</td></tr>
                </tfoot>
              </table>
            </div>
            <div class="plan-summary">
              <h3 class="plan-summary-title">Pricing summary</h3>
              <div class="plan-summary-row">
                <label>Total Value ($)</label>
                <div class="plan-summary-input"></div>
                <strong>{{ formatPlanCurrency(page_data.menual_total.value) }}</strong>
              </div>
              <div class="plan-summary-row">
                <label>Labour (Per/Ct $)</label>
                <div class="plan-summary-input plan-summary-input-compact">
                  <input
                    v-model="page_data.menual_total.labour_per_ct"
                    type="number"
                    step="0.01"
                    class="form-control"
                    @input="getPlanningTotal"
                  />
                </div>
                <strong>{{ formatPlanCurrency(page_data.menual_total.total_labour) }}</strong>
              </div>
              <div class="plan-summary-row">
                <label>Profit (%)</label>
                <div class="plan-summary-input plan-summary-input-compact">
                  <input
                    v-model="page_data.menual_total.profit"
                    type="number"
                    step="0.01"
                    class="form-control"
                    @input="getPlanningTotal"
                  />
                </div>
                <strong>{{ formatPlanCurrency(page_data.menual_total.profit_amount) }}</strong>
              </div>
              <div class="plan-summary-row">
                <label>New Value ($)</label>
                <div class="plan-summary-input"></div>
                <strong>{{ formatPlanCurrency(page_data.menual_total.value_profit) }}</strong>
              </div>
              <div class="plan-summary-row">
                <label>Interest (%)</label>
                <div class="plan-summary-input plan-summary-input-compact">
                  <input
                    v-model="page_data.menual_total.interest"
                    type="number"
                    step="0.01"
                    class="form-control"
                    @input="getPlanningTotal"
                  /><span>%</span
                  ><input
                    v-model="page_data.menual_total.interest_duration"
                    type="number"
                    step="1"
                    min="0"
                    class="form-control"
                    @input="getPlanningTotal"
                  /><span>M</span>
                </div>
                <strong>{{ formatPlanCurrency(page_data.menual_total.interest_amount) }}</strong>
              </div>
              <div class="plan-summary-row">
                <label>New Value ($)</label>
                <div class="plan-summary-input"></div>
                <strong>{{ formatPlanCurrency(page_data.menual_total.value_interest) }}</strong>
              </div>
              <div class="plan-summary-row">
                <label>Duty (%)</label>
                <div class="plan-summary-input plan-summary-input-compact">
                  <input
                    v-model="page_data.menual_total.duty"
                    type="number"
                    step="0.01"
                    class="form-control"
                    @input="getPlanningTotal"
                  />
                </div>
                <strong>{{ formatPlanCurrency(page_data.menual_total.duty_amount) }}</strong>
              </div>
              <div class="plan-summary-row">
                <label>Extra Expense ($)</label>
                <div class="plan-summary-input">
                  <input
                    v-model="page_data.menual_total.extra_expense"
                    type="number"
                    step="0.01"
                    class="form-control"
                    @input="getPlanningTotal"
                  />
                </div>
                <strong></strong>
              </div>
              <div class="plan-summary-row">
                <label>Final Price ($)</label>
                <div class="plan-summary-input"></div>
                <strong>{{ formatPlanCurrency(page_data.menual_total.final_value) }}</strong>
              </div>
              <div class="plan-summary-row">
                <label>Tender Amount ($)</label>
                <div class="plan-summary-input">
                  <input
                    v-model="page_data.menual_total.tender_amount"
                    type="number"
                    step="0.01"
                    class="form-control"
                    @input="getPlanningTotal"
                  />
                </div>
                <strong></strong>
              </div>
            </div>
          <div class="modal-footer plan-scroll-footer text-right">
            <button type="button" data-dismiss="modal" class="btn btn-outline-secondary w-32 mr-1">
              Cancel
            </button>
            <button
              type="button"
              @click="submitManualPlanning"
              :disabled="page_data.loading || planMediaBusy"
              class="btn btn-primary"
            >
              Save Details
              <LoadingIcon v-if="page_data.loading" icon="oval" color="white" class="w-4 h-4 ml-2" />
            </button>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div id="view-manual-planning" ref="view-manual-planning" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog-lg">
        <div class="modal-content">
          <div class="modal-header flex justify-between items-center">
            <div class="flex justify-between items-center w-full">

              <h2 class="font-medium text-base mr-auto">
                View Plans (Lot No: {{ page_data.planning_view.lot_no }}) (Weight {{page_data.planning_view.weight}} Ct)
              </h2>
              <a data-dismiss="modal" href="javascript:;">
                <XIcon class="w-8 h-8 text-gray-500" />
              </a>
            </div>
          </div>
          <div class="modal-body">

            <div class="border-b mt-5" v-for="plan_detail in orderedViewPlans" :key="plan_detail.id">


              <div class="grid grid-cols-12 gap-5">

                <div class="col-span-12">
                      <div class="flex justify-between items-center">
                        <div class="flex flex-wrap">

                          <div class="text-sm font-bold mr-4">Plan No: {{ plan_detail.view_number }}</div>
                          <div class="text-sm font-bold mr-4">Polish WT(Ct): {{ plan_detail.polish_weight ? $h.myFloat(plan_detail.polish_weight) : 0 }} Ct</div>
                          <!-- <div class="text-sm font-bold mr-4">Avg Discount(%): {{ plan_detail.final_value ? $h.myFloat((plan_detail.value - plan_detail.final_value) * 100 / plan_detail.polish_weight ) : 0 }} %</div> -->
                          <div class="text-sm font-bold mr-4">Per/Ct($): {{ plan_detail.per_ct ? $h.myFloat(plan_detail.per_ct) : 0 }} Ct</div>
                          <div class="text-sm font-bold">Final Price($): {{ plan_detail.tender_amount ? $h.myFloat(plan_detail.tender_amount) : 0 }} $</div>
                        </div>
                        <div class="flex items-center justify-end">
                          <button v-if="Number(page_data.planning_view.final_plan_id) === Number(plan_detail.id) || (!hasFinalPlan(page_data.planning_view) && Number(plan_detail.tender_amount || 0) !== 0)" type="button" class="text-xs font-medium px-2.5 py-0.5 rounded mx-2" :class="Number(page_data.planning_view.final_plan_id) === Number(plan_detail.id) ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'" :disabled="finalPlanBusy" @click="toggleFinalPlan(plan_detail)">{{ Number(page_data.planning_view.final_plan_id) === Number(plan_detail.id) ? 'Remove Final' : 'Final' }}</button>
                          <a class="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded mx-2 cursor-pointer" href="javascript:;" @click="duplicate_planning(plan_detail)">
                            <CopyIcon class="w-3 h-3 mr-1" />
                            Duplicate
                          </a>
                          <a class="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded mx-2 cursor-pointer" href="javascript:;" @click="update_planning(plan_detail)">
                            <CheckSquareIcon class="w-3 h-3 mr-1" />
                            Edit
                          </a>
                          <a class="bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded mx-2 cursor-pointer" href="javascript:;" @click="cancel_plan(plan_detail.id)">
                            <TrashIcon class="w-3 h-3 mr-1" />
                            Delete
                          </a>
                          <a
                            class="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded mx-2 cursor-pointer"
                            @click="exportPlanDetails(plan_detail.id)"
                            >Export</a
                          >
                          <a
                           class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded cursor-pointer"
                            @click="printPlanDetails(plan_detail.id)"
                            >
                            <PrintIcon class="w-3 h-3 mr-1" /> Print
                          </a>
                        </div>

                      </div>
                  </div>
              </div>

              <table class="w-full text-center text-xs my-5">
                <thead>
                  <tr class="bg-theme-14">
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">No</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PL No</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PL Wt</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Shp</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Color</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Clarity</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Cut</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Polsh</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Diamond Type</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Inclusion Type</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Brown</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Symm</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Flow</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Ratio</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Table</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Depth</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Back (%)</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">R Rate ($)</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Per / Ct ($)</th>
                    <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Value ($)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="hover:bg-gray-200"
                        :class="{ 'bg-gray-100': inx % 2 == 0 }" v-for="(plan,inx) in plan_detail.plan_detail" :key="inx">
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap"><p>{{ inx + 1 }}</p></td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.part_no}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.polish_weight}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.shape_item ? plan.shape_item.shape_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.color_item ? plan.color_item.color_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.purity_item ? plan.purity_item.purity_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.cut_item ? plan.cut_item.cut_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.polish_item ? plan.polish_item.polish_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.diamond_type_item ? plan.diamond_type_item.type : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.inclusion_type_item ? plan.inclusion_type_item.type : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.brown_item ? plan.brown_item.brown_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.symmetry_item ? plan.symmetry_item.symmetry_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.flow_item ? plan.flow_item.fluerocent_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.ratio_item ? plan.ratio_item.ratio_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.tabl_item ? plan.tabl_item.tabl_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.depth_item ? plan.depth_item.height_name : "-"}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{plan.discount}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{Number(plan.r_rate).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{Number(plan.per_ct).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</td>
                    <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{Number(plan.value).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}}</td>
                  </tr>
                </tbody>


              </table>

              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1 mt-5">

                <div class="col-span-7"></div>
                <div class="col-span-1">
                </div>
                <div class="col-span-2 pr-1">
                  <b>Total Value :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  <b>{{ parseInt(plan_detail.value).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b>
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1">

                <div class="col-span-7"></div>
                <div class="col-span-1 text-right">
                </div>
                <div class="col-span-2">
                  <b>Labour(Per/Ct $) :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  <div class="flex justify-between items-center">
                    <div>

                        $ {{plan_detail.labour_per_ct ? $h.myFloat(plan_detail.labour_per_ct) : 0}}
                    </div>
                    <div>
                      {{plan_detail.total_labour ? parseInt(plan_detail.total_labour).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : 0}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1">

                <div class="col-span-7"></div>
                <div class="col-span-1"></div>
                <div class="col-span-2">
                  <b>Profit(%) :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  <div class="flex justify-between items-center">
                    <div>

                            {{plan_detail.profit ? $h.myFloat(plan_detail.profit) : 0}} %
                    </div>
                    <div>
                      {{plan_detail.profit_amount ? parseInt(plan_detail.profit_amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : 0}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1">

                <div class="col-span-7"></div>
                <div class="col-span-1">
                  <b></b>
                </div>
                <div class="col-span-2 pr-1">
                  <b>New Value :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  <b>{{ parseInt(plan_detail.value_profit).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b>
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1">

                <div class="col-span-7"></div>
                <div class="col-span-1"></div>
                <div class="col-span-2">
                  <b>Interest($) :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  <div class="flex justify-between items-center">
                    <div>

                        ({{plan_detail.interest ? $h.myFloat(plan_detail.interest) : 0}} %)
                       ( {{plan_detail.interest_duration ? $h.myFloat(plan_detail.interest_duration) : 0}} M)
                    </div>
                    <div>
                      {{plan_detail.interest_amount ? parseInt(plan_detail.interest_amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : 0}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1">

                <div class="col-span-7"></div>
                <div class="col-span-1">
                  <b></b>
                </div>
                <div class="col-span-2 pr-1">
                  <b>New Value :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  <b>{{ parseInt(plan_detail.value_interest).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</b>
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1">

                <div class="col-span-7"></div>
                <div class="col-span-1">
                </div>
                <div class="col-span-2">
                  <b>Duty(%) :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  <div class="flex justify-between items-center">
                    <div>

                        {{plan_detail.duty ? $h.myFloat(plan_detail.duty) : 0}} %
                    </div>
                    <div>
                      {{plan_detail.duty_amount ? parseInt(plan_detail.duty_amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : 0}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1 text-primary-4">

                <div class="col-span-7"></div>
                <div class="col-span-1">
                </div>
                <div class="col-span-2">
                  <b>Extra Expense($) :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  {{plan_detail.extra_expense ? parseInt(plan_detail.extra_expense).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : 0}}
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1 text-primary-4">

                <div class="col-span-7"></div>
                <div class="col-span-1">
                </div>
                <div class="col-span-2">
                  <b>Final Price($) :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  {{plan_detail.final_value ? parseInt(plan_detail.final_value).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : 0}}
                </div>
              </div>
              <div class="grid grid-cols-12 items-center gap-4 gap-y-3 text-right py-1 text-primary-4">

                <div class="col-span-7"></div>
                <div class="col-span-1">
                </div>
                <div class="col-span-2">
                  <b>Tender Amount($) :</b>
                </div>
                <div class="col-span-2 pr-1 border-b">
                  {{plan_detail.tender_amount ? parseInt(plan_detail.tender_amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : 0}}
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, inject, onMounted, reactive, ref, watch } from 'vue'
import axios from 'axios'
import datetime from 'vuejs-datetimepicker'
import ParameterOptions from '../estimation/ParameterOptions.vue'
import { useRoute } from 'vue-router'
import { helper as $h } from '@/utils/helper'

import { BASE_URL } from '@/constants/config.js'
import FileDownload from 'js-file-download'
import { canOpenMedia, mediaUrl, mediaUploadLimitMessage } from '@/utils/tenderMedia'

export default defineComponent({
  components: {
    ParameterOptions,
    datetime
  },

  setup() {
    const route = useRoute()
    const tabulator = ref()
    const baseURL = ref(BASE_URL)

    const swal = inject('$swal')

    const page_data = reactive({
      tenderDetail: '',
      finance_expenses: '',
      exportingPlan: false,
      plan_id: 0,
      planning_view: [],
      planning_packet: [],
      manualPlanDetail: [],
      manualPlanning: [],
      menual_total: {
        weight: 0,
        polish_weight: 0,
        value: 0,
        duty: 0,
        duty_amount: 0,
        labour_per_ct: 0,
        total_labour: 0,
        profit: 0,
        profit_amount: 0,
        value_profit: 0,
        value_interest: 0,
        interest: '',
        extra_expense: '',
        tender_amount: '',
        interest_duration: '',
        interest_amount: 0,
        final_value: 0
      }
    })

    const diamond = reactive({
      colors: [],
      cuts: [],
      purities: [],
      symmetry: [],
      polish: [],
      fluerocents: [],
      comments: [],
      tensions: [],
      stones: [],
      shapes: [],
      heights: [],
      ratios: [],
      browns: [],
      diamond_types: [],
      inclusion_types: [],
      tabls: []
    })

    const syncPlanningViewFromTender = tenderDetail => {
      if (!page_data.planning_view?.id || !tenderDetail?.lot_items) {
        return
      }

      const updatedPlanningView = tenderDetail.lot_items.find(
        item => item.id == page_data.planning_view.id
      )

      if (updatedPlanningView) {
        page_data.planning_view = updatedPlanningView
      }
    }

    const getTenderDetails = async id => {
      const params = {
        id: id
      }
      let promise = axios({
        url: 'api/tender/view',
        method: 'POST',
        params: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        config: {
          headers: {
            Accept: 'application/json'
          }
        }
      })
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.tenderDetail = data.item
          syncPlanningViewFromTender(page_data.tenderDetail)

          if (!activeDraft.value) page_data.menual_total.duty = Number(page_data.tenderDetail.location?.duty) || 0
          page_data.finance_expenses = 0

          if (
            page_data.tenderDetail?.tender_winning?.finance_expense_items
              .length > 0
          ) {
            for (const item of page_data.tenderDetail.tender_winning
              .finance_expense_items) {
              page_data.finance_expenses += parseFloat(item.amount) || 0
            }
          }

        })
        .catch(_error => {})
    }

    const formatPlanNumber = (value, decimals) =>
      value == null || value === '' || !Number.isFinite(Number(value)) ? '-' : Number(value).toFixed(decimals)
    const formatPlanCurrency = value =>
      Number(value || 0).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    const planLot = reactive({
      lot_no: '',
      result: 'no_result',
      color: 'no_result',
      blue_uv: '',
      comment: '',
      tension: '',
      weight: 0,
      less: '',
      reserve_price: '',
      final_ppc: '',
      final_total: '',
      video: '',
      cap: '',
      image: '',
      is_new: false
    })
    const planMediaBusy = ref(false)
    const mediaUploadLimitBytes = ref(null)
    const loadPlanLot = (item, saved = {}) => {
      Object.assign(
        planLot,
        {
          lot_no: item.lot_no || '',
          result: item.result ?? 'no_result',
          color: item.color ?? 'no_result',
          blue_uv: item.blue_uv ?? '',
          comment: item.comment ?? '',
          tension: item.tension ?? '',
          weight: item.weight || 0,
          less: '',
          reserve_price: '',
          final_ppc: '',
          final_total: '',
          video: item.video || '',
          cap: item.cap || '',
          image: item.image || '',
          is_new: false
        },
        saved || {}
      )
      if (page_data.tenderDetail.type === 'Single' && String(planLot.lot_no).trim().toLowerCase() === 'single') planLot.lot_no = ''
      planLot.replace_media = {}
      planLot.is_new = false
      planLot.result = item.result ?? saved?.result ?? 'no_result'
      planLot.color = item.color ?? saved?.color ?? 'no_result'
      planLot.blue_uv = item.blue_uv ?? saved?.blue_uv ?? ''
      const comment = item.comment ?? saved?.comment
      const tension = item.tension ?? saved?.tension
      planLot.comment = Number(comment) > 0 ? comment : ''
      planLot.tension = Number(tension) > 0 ? tension : ''
      for (const kind of ['video', 'cap', 'image']) if (item[kind]) planLot[kind] = item[kind]
    }
    const openNewLotPlan = () => {
      new_planning({ lot_no: '', weight: 0 })
      planLot.weight = ''
      planLot.is_new = true
    }
    const newPlanLot = () => {
      startNewPlan()
      currentLotKey.value = 'new-' + (++draftSequence)
      page_data.planning_packet = {}
      loadPlanLot({ lot_no: '', weight: '' })
      planLot.weight = ''
      planLot.is_new = true
      partEntry.part_no = nextLotPlanNumber()
    }
    const uploadPlanMedia = async (kind, event) => {
      const file = event.target.files?.[0]
      if (!file || planMediaBusy.value) return
      planMediaBusy.value = true
      try {
        const body = new FormData()
        body.append('file', file)
        const res = await axios({
          url: 'api/tender/upload',
          method: 'post',
          baseURL: BASE_URL,
          data: body,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        })
        if (!res.data.file_name) throw new Error('Upload response missing file')
        planLot[kind] = res.data.file_name
        planLot.replace_media = { ...planLot.replace_media, [kind]: true }
      } catch (error) {
        const response = error.response
        const tooLarge = response?.status === 413 || /PostTooLargeException/i.test(response?.data?.exception || '')
        const message = tooLarge
          ? mediaUploadLimitMessage(mediaUploadLimitBytes.value)
          : response?.data?.message || response?.data?.error || 'Media upload failed. Please retry.'
        swal('Warning', message, 'warning')
      } finally {
        planMediaBusy.value = false
        event.target.value = ''
      }
    }
    const adjacentRequests = new WeakMap()
    const refreshAdjacentRates = async plan => {
      const version = (adjacentRequests.get(plan) || 0) + 1
      adjacentRequests.set(plan, version)
      for (const field of ['color_up', 'color_down', 'purity_up', 'purity_down']) plan[field] = ''
      if (!(Number(plan.polish_weight) > 0) || !plan.shape || !plan.color || !plan.purity) return
      const shape = diamond.shapes.find(item => item.id == plan.shape)
      const specs = [
        ['color_up', 'color', diamond.colors, -1],
        ['color_down', 'color', diamond.colors, 1],
        ['purity_up', 'purity', diamond.purities, -1],
        ['purity_down', 'purity', diamond.purities, 1]
      ]
      await Promise.all(
        specs.map(async ([output, field, items, offset]) => {
          const index = items.findIndex(item => item.id == plan[field])
          if (index < 0) return
          const neighbor = items[Math.max(0, Math.min(items.length - 1, index + offset))]
          try {
            const res = await axios({
              url: 'api/plan/tender_plan_values',
              method: 'post',
              baseURL: BASE_URL,
              data: { ...plan, [field]: neighbor.id, shape_group: shape?.shape_group, stone: page_data.stone },
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            if (adjacentRequests.get(plan) === version)
              plan[output] = Number(res.data.rape_value) > 0 ? res.data.rape_value : ''
          } catch (_) {}
        })
      )
    }

    const defaultDraftTotals = JSON.parse(JSON.stringify(page_data.menual_total))
    const partLessOverridden = ref(false)
    const partEntry = reactive({})
    const draftPlans = reactive([])
    const activeDraft = ref(null)
    const editingDraftPart = ref(null)
    let draftSequence = 0
    const currentLotKey = ref('')
    const copyDraft = value => JSON.parse(JSON.stringify(value))
    const nextLotPlanNumber = () => {
      const lotId = page_data.planning_packet.id
      const lot = (page_data.tenderDetail.lot_items || []).find(item => lotId && String(item.id) === String(lotId)) || page_data.planning_packet
      const savedPlans = lot.tender_plans || []
      const numbers = savedPlans.map((plan, index) => {
        const number = Number(plan.plan_detail?.[0]?.part_no)
        return Number.isInteger(number) && number > 0 ? number : index + 1
      })
      draftPlans.filter(group => group.lot_key === currentLotKey.value).forEach(group => {
        group.parts.forEach(part => {
          const number = Number(part.part_no)
          if (Number.isInteger(number) && number > 0) numbers.push(number)
        })
      })
      return Math.max(0, ...numbers) + 1
    }
    // Lot numbers belong to the current tender, not to an individual plan.
    const resolveExistingPlanLot = () => {
      if (page_data.planning_packet.id) return
      const lotNumber = String(planLot.lot_no ?? '').trim()
      planLot.lot_no = lotNumber
      if (!lotNumber) return
      const lot = (page_data.tenderDetail.lot_items || []).find(item =>
        String(item.lot_no ?? '').trim() === lotNumber
      )
      if (!lot) return
      const previousKey = currentLotKey.value
      const uploadedMedia = {}
      for (const kind of ['video', 'cap', 'image']) {
        if (planLot.replace_media?.[kind]) uploadedMedia[kind] = planLot[kind]
      }
      page_data.planning_packet = { ...lot }
      currentLotKey.value = 'lot-' + lot.id
      loadPlanLot(lot)
      Object.assign(planLot, uploadedMedia)
      planLot.replace_media = Object.fromEntries(Object.keys(uploadedMedia).map(kind => [kind, true]))
      draftPlans.filter(group => group.lot_key === previousKey).forEach(group => {
        group.lot_key = currentLotKey.value
        group.packet_id = lot.id
        group.lot = copyDraft(planLot)
      })
      loadSavedLotPlans()
      if (!activeDraft.value && !page_data.manualPlanning.length) partEntry.part_no = nextLotPlanNumber()
      refreshLotBidTotals()
    }
    const resetPartEntry = keepNumber => {
      const number = keepNumber ? partEntry.part_no : nextLotPlanNumber()
      adjacentRequests.set(partEntry, (adjacentRequests.get(partEntry) || 0) + 1)
      add_plan_fields()
      partEntry.part_no = number
      editingDraftPart.value = null
    }
    const syncDraft = () => {
      if (!activeDraft.value) return
      activeDraft.value.lot = copyDraft(planLot)
      draftPlans.filter(group => group.lot_key === currentLotKey.value).forEach(group => { group.lot = copyDraft(planLot) })
      activeDraft.value.parts = copyDraft(page_data.manualPlanning)
      activeDraft.value.totals = copyDraft(page_data.menual_total)
    }
    const beginDraft = (id = null) => {
      const group = { key: ++draftSequence, lot_key: currentLotKey.value, packet_id: page_data.planning_packet.id || null, id, lot: copyDraft(planLot), parts: copyDraft(page_data.manualPlanning), totals: copyDraft(page_data.menual_total), savedTenderAmount: id ? page_data.menual_total.tender_amount : 0 }
      draftPlans.push(group)
      activeDraft.value = group
    }
    const loadSavedLotPlans = () => {
      const lotId = page_data.planning_packet.id
      if (!lotId) return
      const lot = (page_data.tenderDetail.lot_items || []).find(item => String(item.id) === String(lotId)) || page_data.planning_packet
      for (const saved of lot.tender_plans || []) {
        if (draftPlans.some(group => group.lot_key === currentLotKey.value && String(group.id) === String(saved.id))) continue
        const totals = copyDraft(defaultDraftTotals)
        Object.keys(totals).forEach(key => { if (saved[key] != null) totals[key] = saved[key] })
        draftPlans.push({
          key: ++draftSequence,
          lot_key: currentLotKey.value,
          packet_id: lotId,
          id: saved.id,
          lot: copyDraft(planLot),
          parts: copyDraft(saved.plan_detail || []),
          totals,
          savedTenderAmount: saved.tender_amount || 0
        })
      }
    }
    const initDraftSession = id => {
      draftPlans.splice(0)
      activeDraft.value = null
      currentLotKey.value = page_data.planning_packet.id ? 'lot-' + page_data.planning_packet.id : 'new-' + (++draftSequence)
      if (page_data.manualPlanning.length) beginDraft(id)
      loadSavedLotPlans()
      resetPartEntry(false)
      if (page_data.manualPlanning.length) partEntry.part_no = page_data.manualPlanning[0].part_no
    }
    const planningValidationErrors = (part, lot) => {
      const errors = []
      const empty = value => value == null || String(value).trim() === ''
      if (empty(lot.lot_no)) errors.push('Lot Number is required.')
      if (empty(lot.weight)) errors.push('Rough Weight is required.')
      else if (!Number.isFinite(Number(lot.weight)) || Number(lot.weight) < 0) errors.push('Rough Weight must be a valid number of 0 or more.')
      const requiredSelections = [
        ['part_no', 'Plan No'], ['shape', 'Shape'], ['color', 'Color'],
        ['purity', 'Purity'], ['cut', 'Cut'], ['polish', 'Polish'],
        ['symmetry', 'Symmetry'], ['fluerocent', 'Fluorescence']
      ]
      requiredSelections.forEach(([field, label]) => {
        if (empty(part[field]) || (field !== 'part_no' && !(Number(part[field]) > 0))) errors.push(label + ' is required')
      })
      if (empty(part.polish_weight)) errors.push('Polish Weight is required.')
      else if (!Number.isFinite(Number(part.polish_weight)) || Number(part.polish_weight) <= 0) errors.push('Polish Weight must be greater than 0.')
      if (empty(part.r_rate) || !Number.isFinite(Number(part.r_rate)) || Number(part.r_rate) <= 0) errors.push('Repo Rate must be greater than 0. Check the weight, Shape, Color and Purity to load pricing.')
      if (empty(part.value) || !Number.isFinite(Number(part.value))) errors.push('Total has not been calculated. Check the pricing before saving.')
      return errors
    }
    const findLotPlan = number => {
      const matches = value => String(value ?? '').trim() === String(number).trim()
      const draft = draftPlans.find(group => group.lot_key === currentLotKey.value && group.parts.some(part => matches(part.part_no)))
      if (draft) return draft
      const lotId = page_data.planning_packet.id
      if (!lotId) return null
      const lot = (page_data.tenderDetail.lot_items || []).find(item => String(item.id) === String(lotId)) || page_data.planning_packet
      const saved = (lot.tender_plans || []).find(plan => (plan.plan_detail || []).some(part => matches(part.part_no)))
      if (!saved) return null
      const totals = copyDraft(defaultDraftTotals)
      Object.keys(totals).forEach(key => { if (saved[key] != null) totals[key] = saved[key] })
      const group = { key: ++draftSequence, lot_key: currentLotKey.value, packet_id: lotId, id: saved.id, lot: copyDraft(planLot), parts: copyDraft(saved.plan_detail), totals, savedTenderAmount: saved.tender_amount || 0 }
      draftPlans.push(group)
      return group
    }
    const selectPlanSummary = (number = partEntry.part_no) => {
      if (page_data.loading || finalPlanBusy.value) return
      const target = findLotPlan(number)
      partEntry.part_no = number
      if (target === activeDraft.value) return
      syncDraft()
      activeDraft.value = target
      editingDraftPart.value = null
      page_data.manualPlanDetail = target?.id ? { id: target.id } : []
      page_data.manualPlanning = target ? copyDraft(target.parts) : []
      Object.assign(page_data.menual_total, copyDraft(target?.totals || defaultDraftTotals))
      getPlanningTotal()
    }
    const lotWeightError = parts => {
      const total = parts.reduce((sum, part) => sum + Number(part.polish_weight || 0), 0)
      return total - Number(planLot.weight) > 0.00000001
        ? 'Total polish weight for this plan (' + total.toFixed(3) + ' Ct) cannot exceed the lot rough weight (' + Number(planLot.weight).toFixed(3) + ' Ct).'
        : ''
    }
    const stagePlanPart = async () => {
      if (page_data.loading || planMediaBusy.value) return
      if (!planningParamsReady.value) { get_params(); return }
      resolveExistingPlanLot()
      const errors = planningValidationErrors(partEntry, planLot)
      if (errors.length) {
        swal({
          text: errors.join('\n'),
          icon: 'warning',
          didOpen: popup => { popup.querySelector('.swal2-html-container').style.whiteSpace = 'pre-line' }
        })
        return
      }
      if (editingDraftPart.value === null) {
        const target = findLotPlan(partEntry.part_no)
        if (target && target !== activeDraft.value) {
          syncDraft()
          activeDraft.value = target
          page_data.manualPlanDetail = target.id ? { id: target.id } : []
          page_data.manualPlanning = copyDraft(target.parts)
          Object.assign(page_data.menual_total, copyDraft(target.totals))
        }
      }
      if (editingDraftPart.value === null && page_data.manualPlanning.length && String(partEntry.part_no) !== String(page_data.manualPlanning[0].part_no)) {
        const enteredPart = copyDraft(partEntry)
        const lessOverridden = partLessOverridden.value
        startNewPlan()
        Object.assign(partEntry, enteredPart)
        partLessOverridden.value = lessOverridden
      }
      if (!activeDraft.value) beginDraft(page_data.manualPlanDetail.id || null)
      const group = activeDraft.value
      const proposedParts = copyDraft(page_data.manualPlanning)
      if (editingDraftPart.value !== null) proposedParts.splice(editingDraftPart.value, 1, copyDraft(partEntry))
      else proposedParts.push(copyDraft(partEntry))
      const weightError = lotWeightError(proposedParts)
      if (weightError) { swal('Polish Weight Exceeded', weightError, 'warning'); return }
      const previousParts = copyDraft(page_data.manualPlanning)
      const previousTotals = copyDraft(group.totals)
      page_data.manualPlanning.forEach(part => { part.part_no = partEntry.part_no })
      calculateBidPart(partEntry, planLot.weight)
      partEntry.machine_comment = planLot.comment
      partEntry.tension = planLot.tension
      const entry = copyDraft(partEntry)
      if (editingDraftPart.value !== null) page_data.manualPlanning.splice(editingDraftPart.value, 1, entry)
      else page_data.manualPlanning.push(entry)
      getPlanningTotal()
      syncDraft()
      page_data.loading = true
      try {
        const res = await axios({ url: 'api/tender/save_plan_batch', method: 'post', baseURL: BASE_URL, headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }, data: { tender_id: page_data.tenderDetail.id, plans: [{ lot_key: group.lot_key, packet_id: group.packet_id, id: group.id, lot_context: group.lot, packet_plans: group.parts.map(part => ({ ...part, _lot: group.lot })), menual_total: { ...group.totals, tender_amount: group.savedTenderAmount } }] } })
        if (res.data.status !== 'success') throw new Error(res.data.msg || 'Unable to save entry.')
        const saved = res.data.plans[0]
        group.id = saved.plan_id
        draftPlans.filter(item => item.lot_key === group.lot_key).forEach(item => {
          item.packet_id = saved.packet_id
          item.lot.is_new = false
          item.lot.replace_media = {}
        })
        page_data.planning_packet = { ...copyDraft(planLot), id: saved.packet_id, is_new: false, replace_media: {} }
        page_data.manualPlanDetail = { id: group.id }
        planLot.is_new = false
        planLot.replace_media = {}
        resetPartEntry(true)
        getTenderDetails(route.params.id).catch(() => {})
      } catch (error) {
        page_data.manualPlanning = previousParts
        group.parts = copyDraft(previousParts)
        group.totals = previousTotals
        getPlanningTotal()
        const serverErrors = Object.values(error.response?.data?.errors || {}).flat()
        swal('Warning', serverErrors.length ? serverErrors.join('\n') : error.response?.data?.message || error.message || 'Unable to save entry. Please try again.', 'warning')
      } finally { page_data.loading = false }
    }
    const startNewPlan = () => {
      syncDraft()
      activeDraft.value = null
      page_data.manualPlanDetail = []
      page_data.manualPlanning = []
      Object.assign(page_data.menual_total, copyDraft(defaultDraftTotals))
      getPlanningTotal()
      resetPartEntry(false)
    }
    const editDraftPart = (group, index) => {
      syncDraft()
      activeDraft.value = group
      currentLotKey.value = group.lot_key
      page_data.planning_packet = { id: group.packet_id, ...copyDraft(group.lot) }
      Object.assign(planLot, copyDraft(group.lot))
      page_data.manualPlanDetail = group.id ? { id: group.id } : []
      page_data.manualPlanning = copyDraft(group.parts)
      Object.assign(page_data.menual_total, copyDraft(group.totals))
      Object.keys(partEntry).forEach(key => delete partEntry[key])
      Object.assign(partEntry, copyDraft(group.parts[index]))
      if (partEntry.polish_weight != null && partEntry.polish_weight !== '' && Number.isFinite(Number(partEntry.polish_weight))) {
        partEntry.polish_weight = Number(partEntry.polish_weight).toFixed(3)
      }
      partLessOverridden.value = true
      editingDraftPart.value = index
      refreshAdjacentRates(partEntry)
    }
    const planPolishPercentage = group => {
      const roughWeight = Number(group.lot.weight)
      if (!Number.isFinite(roughWeight) || roughWeight <= 0) return '-'
      const polishWeight = group.parts.reduce((sum, part) => sum + Number(part.polish_weight || 0), 0)
      return ((polishWeight / roughWeight) * 100).toFixed(2)
    }
    const draftTableRows = computed(() => {
      const lots = new Map()
      draftPlans.filter(group => group.lot_key === currentLotKey.value && group.parts.length).forEach(group => { if (!lots.has(group.lot_key)) lots.set(group.lot_key, []); lots.get(group.lot_key).push(group) })
      const rows = []
      lots.forEach(groups => { const lotCount = groups.reduce((total, group) => total + group.parts.length, 0); let first = true; groups.forEach((group, planIndex) => group.parts.forEach((part, index) => { rows.push({ group, part, index, planIndex, lotSpan: first ? lotCount : 0, planSpan: index === 0 ? group.parts.length : 0 }); first = false })) })
      return rows
    })
    const draftTableTotals = computed(() => draftTableRows.value.reduce((total, row) => ({ weight: total.weight + Number(row.part.polish_weight || 0), value: total.value + Number(row.part.value || 0), bidFinalTotal: total.bidFinalTotal + Number(row.part.bid_final_total || 0) }), { weight: 0, value: 0, bidFinalTotal: 0 }))

    watch(() => planLot.less, value => {
      if (!partLessOverridden.value) partEntry.bid_less = value
    }, { flush: 'sync' })
    const calculateBidPart = (part, weight) => {
      const rough = Number(weight)
      const total = Number(part.value)
      if (!(rough > 0) || !Number.isFinite(total) || part.value === '' || part.value == null) { part.bid_ppc = ''; part.bid_final_total = ''; return }
      part.bid_ppc = (total / rough).toFixed(2)
      part.bid_final_total = (Number(part.bid_ppc) * (1 - Number(part.bid_less || 0) / 100)).toFixed(2)
    }
    const refreshLotBidTotals = () => {
      calculateBidPart(partEntry, planLot.weight)
      const parts = []
      draftPlans.filter(group => group.lot_key === currentLotKey.value).forEach(group => {
        const rows = activeDraft.value?.key === group.key ? page_data.manualPlanning : group.parts
        rows.forEach((part, index) => { calculateBidPart(part, planLot.weight); if (!(activeDraft.value?.key === group.key && editingDraftPart.value === index)) parts.push(part) })
      })
      const lot = page_data.tenderDetail?.lot_items?.find(item => item.id == page_data.planning_packet.id)
      const represented = new Set(draftPlans.map(group => Number(group.id)).filter(Boolean))
      ;(lot?.tender_plans || []).filter(plan => !represented.has(Number(plan.id))).forEach(plan => (plan.plan_detail || []).forEach(part => { const copy = { ...part }; calculateBidPart(copy, planLot.weight); parts.push(copy) }))
      if (Number(partEntry.polish_weight) > 0) parts.push(partEntry)
      planLot.final_ppc = parts.reduce((sum, part) => sum + Number(part.per_ct || 0), 0).toFixed(2)
      planLot.final_total = Number(planLot.weight) > 0 ? parts.reduce((sum, part) => sum + Number(part.bid_final_total || 0), 0).toFixed(2) : ''
    }
    watch(() => [partEntry.value, partEntry.per_ct, partEntry.polish_weight, partEntry.bid_less, planLot.weight, currentLotKey.value, editingDraftPart.value, draftPlans.map(group => [group.key, group.id, group.parts.map(part => [part.value, part.per_ct, part.bid_less])])], refreshLotBidTotals, { deep: true })

    const draftLabel = (items, id, field) => items.find(item => String(item.id) === String(id))?.[field] || '-'

    const add_plan_fields = () => {
      page_data.plan_id++

      let plan_detail = {
        id: page_data.plan_id,
        part_no: '',
        shape: '',
        color: '',
        purity: '',
        cut: '',
        cut_discount: '',
        polish: '',
        symmetry: '',
        symmetry_discount: '',
        fluerocent: '',
        fluerocent_discount: '',
        tabl: '',
        height: '',
        ratio: '',
        polish_weight: '',
        discount: '',
        adjustment_discount: '',
        final_discount: '',
        brown: '',
        brown_discount: '',
        diamond_type: '',
        diamond_type_discount: '',
        inclusion_type: '',
        inclusion_type_discount: '',
        size: 5,
        r_rate: '',
        per_ct: '',
        value: ''
      }

      Object.assign(plan_detail, {
        bid_ppc: '',
        bid_less: planLot.less,
        bid_final_total: '',
        machine_comment: planLot.comment,
        tension: planLot.tension,
        remark: ''
      })
      Object.keys(partEntry).forEach(key => delete partEntry[key])
      partLessOverridden.value = false
      Object.assign(partEntry, plan_detail)
    }

    const removeField = id => {
      swal({
        title: 'Are you sure?',
        text: 'You are about to delete a item!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
        showLoaderOnConfirm: true,
        cancelButtonText: 'Cancel',

        allowOutsideClick: () => !swal.isLoading()
      }).then(result => {
        if (result.isConfirmed) {
          var i = page_data.manualPlanning.length
          while (i--) {
            if (page_data.manualPlanning[i]['id'] == id) {
              page_data.manualPlanning.splice(i, 1)
            }
          }
        }
      })
    }

    const updateSize = (size, plan) => {

      plan.size = size
      loadPlanningValues(plan, 'repo')
    }

    const selectPlanParameter = (plan, field, value, pricingType) => {
      const row = plan
      row[field] = value
      loadPlanningValues(row, pricingType)
    }

    const manualDiscountPlanIds = new Set()
    const updatePlanDiscount = plan => {
      manualDiscountPlanIds.add(plan.id)
      calculate_value(plan)
    }
    const loadPlanningValues = (plan, type) => {
      refreshAdjacentRates(plan)
      getPlanningTotal()
      if (type == 'repo') {
      }
      if (type == 'diamond_type') {
        diamond.diamond_types.forEach(element => {
          if (element.id == plan.diamond_type) {
            plan.diamond_type_discount = element.discount
          }
        })
      }
      if (type == 'inclusion_type') {
        diamond.inclusion_types.forEach(element => {
          if (element.id == plan.inclusion_type) {
            plan.inclusion_type_discount = element.discount
          }
        })
      }
      if (type == 'brown') {
        diamond.browns.forEach(element => {
          if (element.id == plan.brown) {
            plan.brown_discount = element.discount
          }
        })
      }
      if (type == 'cut') {
        diamond.cuts.forEach(element => {
          if (element.id == plan.cut) {
            plan.cut_discount = element.discount
          }
        })
      }
      if (type == 'symmetry') {
        diamond.symmetry.forEach(element => {
          if (element.id == plan.symmetry) {
            plan.symmetry_discount = element.discount
          }
        })
      }
      if (type == 'fluerocent') {
        diamond.fluerocents.forEach(element => {
          if (element.id == plan.fluerocent) {
            plan.fluerocent_discount = element.discount
          }
        })
      }
      if (plan.polish_weight != '' && plan.color != '' && plan.purity != '' && plan.shape != '') {
        let shape_name = ''
        var i = diamond.shapes.length
        while (i--) {
          if (diamond.shapes[i]['id'] == plan.shape) {
            shape_name = diamond.shapes[i]['shape_group']
          }
        }
        let params = {
          color: plan.color,
          cut: plan.cut,
          purity: plan.purity,
          polish: plan.polish,
          symmetry: plan.symmetry,
          fluerocent: plan.fluerocent,
          tension: planLot.tension,
          height: plan.height,
          ratio: plan.ratio,
          tabl: plan.tabl,
          shape: plan.shape,
          shape_group: shape_name,
          polish_weight: plan.polish_weight,
          stone: page_data.stone,
          size: plan.size
        }
        const pricedEntryId = plan.id
        axios({
          url: 'api/plan/tender_plan_values',
          method: 'post',
          baseURL: BASE_URL,
          data: params,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
          config: { headers: { Accept: 'application/json' } }
        }).then(res => {
          if (plan.id !== pricedEntryId) return
          let rap_value = res.data.rape_value
          let back = res.data.back

          plan.r_rate = rap_value
          if (!manualDiscountPlanIds.has(plan.id)) plan.discount = back

          calculate_value(plan)
        })
      }
    }

    const calculate_value = (plan) => {

      if(plan.r_rate != "")

        plan.r_rate = Number(plan.r_rate)

        plan.final_discount = parseFloat(parseFloat(plan.discount ? plan.discount : 0) + parseFloat(plan.adjustment_discount ? plan.adjustment_discount : 0) + parseFloat(plan.cut_discount ? plan.cut_discount : 0) + parseFloat(plan.symmetry_discount ? plan.symmetry_discount : 0) + parseFloat(plan.fluerocent_discount ? plan.fluerocent_discount : 0) + parseFloat(plan.brown_discount ? plan.brown_discount : 0) + parseFloat(plan.diamond_type_discount ? plan.diamond_type_discount : 0) + parseFloat(plan.inclusion_type_discount ? plan.inclusion_type_discount : 0)).toFixed(2)
        if (plan.final_discount) {
          plan.per_ct = parseFloat(
            plan.r_rate + (plan.r_rate * (plan.final_discount ? plan.final_discount : 0)) / 100
          ).toFixed(2)
          plan.value = parseFloat(plan.per_ct * plan.polish_weight).toFixed(2)
        }

        getPlanningTotal();
    }

    const getPlanningTotal = () => {

      console.log("Calculating Values")
      let length = page_data.manualPlanning.length

      page_data.menual_total.polish_weight = 0
      page_data.menual_total.value = 0

      for (let i = 0; i < length; i++) {
        page_data.menual_total.polish_weight = parseFloat(
          parseFloat(page_data.menual_total.polish_weight) +
            parseFloat(
              page_data.manualPlanning[i]['polish_weight']
                ? page_data.manualPlanning[i]['polish_weight']
                : 0
            )
        ).toFixed(4)
        page_data.menual_total.value = parseFloat(
          parseFloat(page_data.menual_total.value) +
            parseFloat(
              page_data.manualPlanning[i]['value']
                ? page_data.manualPlanning[i]['value']
                : 0
            )
        )
      }

      page_data.menual_total.total_labour = parseInt(page_data.menual_total.polish_weight * page_data.menual_total.labour_per_ct);
      page_data.menual_total.profit_amount = parseInt(page_data.menual_total.value * page_data.menual_total.profit / 100);
      page_data.menual_total.value_profit = parseInt(parseFloat(page_data.menual_total.value) - parseFloat(page_data.menual_total.total_labour) - parseFloat(page_data.menual_total.profit_amount));
      page_data.menual_total.interest_amount = parseInt(page_data.menual_total.value_profit * (page_data.menual_total.interest ? page_data.menual_total.interest : 0) * (page_data.menual_total.interest_duration ? page_data.menual_total.interest_duration : 0) / 100);
      page_data.menual_total.value_interest = parseInt(page_data.menual_total.value_profit - page_data.menual_total.interest_amount);
      page_data.menual_total.duty_amount = parseInt(page_data.menual_total.value_interest * (page_data.menual_total.duty ? page_data.menual_total.duty : 0) / 100);
      page_data.menual_total.final_value = parseInt(page_data.menual_total.value_interest - page_data.menual_total.duty_amount - (page_data.menual_total.extra_expense ? page_data.menual_total.extra_expense : 0));
      syncDraft()
    }

    const planningParamsReady = ref(false)
    const planningParamsLoading = ref(false)
    const planningParamsError = ref('')
    let planningParamsRequest = null
    const get_params = () => {
      if (planningParamsReady.value) return Promise.resolve(true)
      if (planningParamsRequest) return planningParamsRequest
      planningParamsLoading.value = true
      planningParamsError.value = ''
      planningParamsRequest = (async () => {
        try {
          for (let attempt = 0; attempt < 2; attempt++) {
            try {
              const request = url => axios({ url, method: 'post', baseURL: BASE_URL, timeout: 20000, headers: { Authorization: 'Bearer ' + localStorage.getItem('token'), Accept: 'application/json' } })
              const [master, tender] = await Promise.all([request('api/master/get_all_parameters'), request('api/tender/params')])
              const fields = { colors: 'color', cuts: 'cut', purities: 'purity', polish: 'polish', shapes: 'shape', symmetry: 'symmetry', fluerocents: 'fluerocent', tensions: 'tension', stones: 'stone', heights: 'height', tabls: 'tabl', ratios: 'ratio', browns: 'browns', diamond_types: 'diamond_types', inclusion_types: 'inclusion_types' }
              const values = {}
              for (const [field, key] of Object.entries(fields)) {
                if (!Array.isArray(master.data?.[key])) throw new Error('Invalid planning options response')
                values[field] = [...master.data[key]]
              }
              if (['colors', 'cuts', 'purities', 'polish', 'shapes', 'symmetry', 'fluerocents'].some(field => !values[field].length)) throw new Error('Required planning options are empty')
              if (!Array.isArray(tender.data?.comment)) throw new Error('Invalid planning comments response')
              values.colors.sort((a, b) => Number(a.color_order) - Number(b.color_order))
              values.purities.sort((a, b) => Number(a.purity_order) - Number(b.purity_order))
              Object.assign(diamond, values, { comments: tender.data.comment })
              mediaUploadLimitBytes.value = Number(tender.data.media_upload_limit_bytes) || null
              planningParamsReady.value = true
              return true
            } catch (error) {
              if (attempt === 1 || [401, 403].includes(error.response?.status)) throw error
            }
          }
        } catch (error) {
          planningParamsError.value = [401, 403].includes(error.response?.status)
            ? 'Your session could not load planning options. Please sign in again.'
            : 'Unable to load planning options. Please retry. If this continues, the server needs attention.'
          return false
        } finally {
          planningParamsLoading.value = false
          planningParamsRequest = null
        }
      })()
      return planningParamsRequest
    }

    const new_planning = item => {
      get_params()
      draftPlans.splice(0)
      activeDraft.value = null
      page_data.manualPlanDetail = []
      page_data.manualPlanning = []
      page_data.menual_total.tender_amount = ''
      getPlanningTotal()
      add_plan_fields()

      if (page_data.tenderDetail.active_status == 1) {
        page_data.planning_packet = { ...item }
        loadPlanLot(item)
        initDraftSession(null)
        cash('#new-manual-planning').modal('show')
      } else if (page_data.tenderDetail.active_status == 2) {
        swal('Warning', 'Teder Already Won', 'warning')
      } else if (page_data.tenderDetail.active_status == 3) {
        swal('Warning', 'Teder Already Cancelled', 'warning')
      }
    }
    const fillManualTotalFromPlan = plan => {
      page_data.menual_total.polish_weight = Number(plan.polish_weight)
      page_data.menual_total.value = Number(plan.value)
      page_data.menual_total.duty = Number(plan.duty)
      page_data.menual_total.duty_amount = Number(plan.duty_amount)
      page_data.menual_total.labour_per_ct = Number(plan.labour_per_ct)
      page_data.menual_total.total_labour = Number(plan.total_labour)
      page_data.menual_total.profit = Number(plan.profit)
      page_data.menual_total.profit_amount = Number(plan.profit_amount)
      page_data.menual_total.value_profit = Number(plan.value_profit)
      page_data.menual_total.value_interest = Number(plan.value_interest)
      page_data.menual_total.interest = Number(plan.interest)
      page_data.menual_total.interest_duration = Number(plan.interest_duration)
      page_data.menual_total.interest_amount = Number(plan.interest_amount)
      page_data.menual_total.final_value = Number(plan.final_value)
      page_data.menual_total.extra_expense = Number(plan.extra_expense)
      page_data.menual_total.tender_amount = plan.tender_amount
      loadPlanLot(page_data.planning_packet, plan.plan_detail?.[0]?._lot)
    }

    const duplicate_planning = (update_plan) => {
      get_params()
      if(page_data.tenderDetail.active_status == 1) {
        page_data.manualPlanDetail = []
        page_data.planning_packet = page_data.planning_view
        page_data.manualPlanning = update_plan.plan_detail.map(plan => {
          const duplicatePlan = JSON.parse(JSON.stringify(plan))
          page_data.plan_id++
          duplicatePlan.id = page_data.plan_id
          delete duplicatePlan.tender_plan_id
          delete duplicatePlan.created_at
          delete duplicatePlan.updated_at
          return duplicatePlan
        })
          console.log('Test');
        fillManualTotalFromPlan(update_plan)
        initDraftSession(null)
        const number = nextLotPlanNumber()
        page_data.manualPlanning.forEach(part => { part.part_no = number })
        partEntry.part_no = number
        syncDraft()
        cash('#new-manual-planning').modal('show')

      } else if(page_data.tenderDetail.active_status == 2) {
        swal("Warning", "Teder Already Won", "warning")

      } else if(page_data.tenderDetail.active_status == 3) {
        swal("Warning", "Teder Already Cancelled", "warning")
      }
    }

    const update_planning = update_plan => {
      get_params()
      if (page_data.tenderDetail.active_status == 1) {
        // page_data.planning_packet = item;
        page_data.manualPlanDetail = update_plan
        page_data.planning_packet = page_data.planning_view
        page_data.manualPlanning = JSON.parse(JSON.stringify(update_plan.plan_detail))
        // page_data.menual_total.weight = page_data.manualPlanDetail.weight;
        fillManualTotalFromPlan(page_data.manualPlanDetail)
        page_data.manualPlanning.forEach(refreshAdjacentRates)
        initDraftSession(update_plan.id)
        // page_data.menual_total.tender_amount = Number(page_data.manualPlanDetail.tender_amount);

        cash('#new-manual-planning').modal('show')
      } else if (page_data.tenderDetail.active_status == 2) {
        swal('Warning', 'Teder Already Won', 'warning')
      } else if (page_data.tenderDetail.active_status == 3) {
        swal('Warning', 'Teder Already Cancelled', 'warning')
      }
    }

    async function submitManualPlanning() {
      if (page_data.loading || planMediaBusy.value) return
      selectPlanSummary()
      const group = activeDraft.value
      if (!group?.id) {
        const message = 'Please click New Tag to save the plan before saving the tender amount.'
        swal('Save Required', message, 'warning')
        return
      }
      const amount = Number(page_data.menual_total.tender_amount)
      if (!Number.isFinite(amount) || amount <= 0) { swal('Warning', 'Enter a valid Tender Amount.', 'warning'); return }
      if (planLot.weight === '' || !Number.isFinite(Number(planLot.weight)) || Number(planLot.weight) < 0) { swal('Warning', 'Enter a valid Rough Weight of 0 or more.', 'warning'); return }
      if (planLot.less !== '' && !Number.isFinite(Number(planLot.less))) { swal('Warning', 'Enter a valid Less percentage.', 'warning'); return }
      if (planLot.reserve_price !== '' && (!Number.isFinite(Number(planLot.reserve_price)) || Number(planLot.reserve_price) < 0)) { swal('Warning', 'Enter a valid Reserve Price of 0 or more.', 'warning'); return }
      const weightError = lotWeightError(page_data.manualPlanning)
      if (weightError) { swal('Polish Weight Exceeded', weightError, 'warning'); return }
      refreshLotBidTotals()
      const lot = copyDraft(planLot)
      const totals = { ...copyDraft(page_data.menual_total), tender_amount: amount }
      const parts = page_data.manualPlanning.map(part => ({ ...copyDraft(part), _lot: lot }))
      page_data.loading = true
      try {
        const res = await axios({
          url: 'api/tender/save_plan_batch',
          method: 'post',
          baseURL: BASE_URL,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
          data: {
            tender_id: page_data.tenderDetail.id,
            plans: [{ lot_key: group.lot_key, packet_id: group.packet_id, id: group.id, lot_context: lot, packet_plans: parts, menual_total: totals }]
          }
        })
        if (res.data.status !== 'success') { swal('Warning', res.data.msg, 'warning'); return }
        group.lot = lot
        group.parts = parts
        group.totals = totals
        group.savedTenderAmount = amount
        swal('Success', 'Details saved successfully.', 'success')
        await getTenderDetails(route.params.id)
      } catch (error) {
        const serverErrors = Object.values(error.response?.data?.errors || {}).flat()
        swal('Warning', serverErrors.length ? serverErrors.join('\n') : error.response?.data?.message || 'Unable to save details. Please try again.', 'warning')
      }
      finally { page_data.loading = false }
    }

    const orderedViewPlans = computed(() => {
      const finalId = Number(page_data.planning_view.final_plan_id)
      return (page_data.planning_view.tender_plans || []).map((plan, index) => ({ ...plan, view_number: index + 1 }))
        .sort((a, b) => Number(Number(b.id) === finalId) - Number(Number(a.id) === finalId))
    })
    const finalLotPrice = (lot, field) => {
      const plan = (lot.tender_plans || []).find(plan => Number(plan.id) === Number(lot.final_plan_id))
      return plan ? Number(plan[field] || 0).toFixed(2) : ''
    }
    const finalPlanBusy = ref(false)
    const draftPlanningLot = computed(() =>
      (page_data.tenderDetail.lot_items || []).find(lot => String(lot.id) === String(page_data.planning_packet.id)) || page_data.planning_packet
    )
    const hasFinalPlan = lot => !!lot?.final_plan_id && (lot.tender_plans || []).some(plan => Number(plan.id) === Number(lot.final_plan_id))
    const toggleFinalPlan = async (plan, selectedLot = page_data.planning_view) => {
      if (finalPlanBusy.value) return
      const remove = Number(selectedLot.final_plan_id) === Number(plan.id)
      const tenderAmount = Number(plan.savedTenderAmount ?? plan.tender_amount)
      if (!remove && (!Number.isFinite(tenderAmount) || tenderAmount <= 0)) {
        const planNumber = plan.parts?.[0]?.part_no ?? plan.plan_detail?.[0]?.part_no ?? plan.view_number ?? '-'
        swal('Tender Amount Required', 'Please add a tender amount for Plan No. ' + planNumber + '.', 'warning')
        return
      }
      const answer = await swal({ title: remove ? 'Remove Final' : 'Final Plan', text: remove ? 'Are you sure you want to remove this plan from Final?' : 'Are you sure you want to finalize this plan?', icon: 'question', showCancelButton: true, confirmButtonText: remove ? 'Remove Final' : 'Final', confirmButtonColor: '#164e63' })
      if (!answer.isConfirmed) return
      finalPlanBusy.value = true
      try {
        const response = await axios({ url: 'api/tender/final_plan', method: 'post', baseURL: BASE_URL, data: { plan_id: plan.id, is_final: !remove }, headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } })
        if (response.data.status !== 'success') throw new Error(response.data.msg)
        const lot = page_data.tenderDetail.lot_items.find(item => Number(item.id) === Number(response.data.lot_id))
        if (lot) lot.final_plan_id = response.data.final_plan_id
        if (Number(page_data.planning_view.id) === Number(response.data.lot_id)) page_data.planning_view.final_plan_id = response.data.final_plan_id
        if (Number(page_data.planning_packet.id) === Number(response.data.lot_id)) page_data.planning_packet.final_plan_id = response.data.final_plan_id
        page_data.tenderDetail.total_amount = response.data.total_amount
        page_data.tenderDetail.total_weight = response.data.total_weight
      } catch (error) { swal('Warning', error.response?.data?.msg || error.message || 'Unable to update Final selection.', 'warning'); await getTenderDetails(route.params.id) }
      finally { finalPlanBusy.value = false }
    }

    const cancel_plan = id => {
      const params = { id: btoa(id) }

      swal({
        title: 'Are you sure?',
        text: 'Do you want to delete plan?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, cancel it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          axios({
            url: 'api/tender/cancle_plan',
            method: 'post',
            baseURL: BASE_URL,
            data: params,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token')
            },
            config: { headers: { Accept: 'application/json' } }
          })
            .then(res => {

              if(res.data.status == "error") {
                swal("Warning", res.data.mfg, "warning")
              } else {
                page_data.menual_total.labour_per_ct = 0
                page_data.menual_total.profit = 0
                page_data.menual_total.interest = ""
                page_data.menual_total.interest_duration = ""

                getTenderDetails(route.params.id)
                cash('#view-manual-planning').modal('hide');

                swal({
                  text: res.data.msg,
                  icon: 'success',
                  buttonsStyling: false,
                  confirmButtonText: 'Ok, got it!',
                  heightAuto: false,
                  customClass: {
                    confirmButton: 'btn btn-sm btn-primary btm-sm py-2'
                  }
                })
              }
            })
            .catch(error => {
              // Handle error if needed
            })
        }
      })
    }

    const view_planning = (item) => {
      page_data.planning_view = item;
    }

    const exportReportDetails = () =>{

      const today = new Date();
      const date = today.getDate() + '' + (today.getMonth() + 1) + '' + today.getFullYear();
      // const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date;
      let filename = "Tender_" +dateTime + ".xlsx";

      let promise = axios({
          url: "/api/tender/lots_export",
          method: "post",
          data: {
            id: route.params.id
          },
          baseURL: BASE_URL,
          headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
          },
          config: {
              headers: {
                  Accept: "application/json"
              }
          },
          // responseType: "blob",
      })

      return promise
          .then((result) => result.data)
          .then((data) => {

            console.log(data)
            if(data.url) {
              window.open(data.url, "_blank");
            }
            //   FileDownload(data, filename);
          })
          .catch((_error) => {
              return []
          })
      }
    const exportReportPlanDetails = () =>{
        page_data.exportingPlan = true
      
      const today = new Date();
      const date = today.getDate() + '' + (today.getMonth() + 1) + '' + today.getFullYear();
      const dateTime = date;
      let filename = "Tender_With_Plan_" +dateTime + ".xlsx";
      // console.log(new Date().toLocaleString());
      let promise = axios({
          url: "/api/tender/lotswithplan_export",
          method: "post",
          data: {
            id: route.params.id,
            auto_width: true
          },
          baseURL: BASE_URL,
          headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
          },
          config: {
              headers: {
                  Accept: "application/json"
              }
          },
      })

      return promise
          .then((result) => result.data)
          .then((data) => {
            if(data.url) {
               
              window.open(data.url, "_blank");
            }
          })
          .catch((_error) => {
              return []
          })
          .finally(() => {
            page_data.exportingPlan = false
           // console.log('its over '+new Date().toLocaleString());
          })
      }
    const exportPlanDetails = (id) =>{

      const today = new Date();
      const date = today.getDate() + '' + (today.getMonth() + 1) + '' + today.getFullYear();
      // const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date;
      let filename = "Plan_" +dateTime + ".xlsx";

      let promise = axios({
          url: "/api/tender/plan_export",
          method: "post",
          data: {
            id: window.btoa(id)
          },
          baseURL: BASE_URL,
          headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
          },
          config: {
              headers: {
                  Accept: "application/json"
              }
          },
      })

      return promise
          .then((result) => result.data)
          .then((data) => {
            // console.log(data)
            //   FileDownload(data, filename);
            //console.log(data)
            if(data.url) {
              window.open(data.url, "_blank");
            }
          })
          .catch((_error) => {
              return []
          })
      }
    const printReportDetails = () =>{

      let url = BASE_URL + 'tender-print/' + route.params.id;
      window.open(url, '_blank');
      }
    const printPlanDetails = (id) =>{

      let url = BASE_URL + 'plan-print/' + window.btoa(id);
      window.open(url, '_blank');
      }

    onMounted(() => {
      getTenderDetails(route.params.id)
      get_params()
    })
    return {
      page_data,
      tabulator,
      getTenderDetails,
      baseURL,
      planLot,
      resolveExistingPlanLot,
      planMediaBusy,
      mediaUrl,
      canOpenMedia,
      uploadPlanMedia,
      openNewLotPlan, newPlanLot, partEntry, partLessOverridden, draftPlans, draftTableRows, draftTableTotals, planPolishPercentage, stagePlanPart, startNewPlan, resetPartEntry, editDraftPart, draftLabel,
      formatPlanCurrency,
      add_plan_fields,
      removeField,
      diamond,
      new_planning,
      selectPlanParameter,
      loadPlanningValues,
      calculate_value,
      updatePlanDiscount,
      getPlanningTotal,
      update_planning,
      duplicate_planning,
      view_planning,
      submitManualPlanning,
      orderedViewPlans, finalLotPrice, finalPlanBusy, hasFinalPlan, toggleFinalPlan, draftPlanningLot, selectPlanSummary, formatPlanNumber,
      planningParamsReady, planningParamsLoading, planningParamsError, get_params,
      cancel_plan,
      updateSize,
      exportReportDetails,
      exportReportPlanDetails,
      exportPlanDetails,
      printReportDetails,
      printPlanDetails
      // onMounted
      // TotalAmount
    }
  }
})
</script>
<style scoped>
.plan-media-open { margin-left: 6px; padding: 5px 7px !important; text-decoration: none !important; }
.plan-media-upload { padding: 5px 7px !important; }

.plan-entry :deep(.parameter-option:hover),
.plan-entry :deep(.parameter-option:focus-visible),
.plan-entry :deep(.parameter-option:active),
.plan-media-actions .btn:hover,
.plan-media-actions .btn:focus-visible,
.plan-media-actions .btn:active {
  background-color: #164e63 !important;
  border-color: #164e63 !important;
  color: #fff !important;
}
.plan-media-actions .btn-outline-primary {
  border-color: #164e63;
  color: #164e63;
}
.plan-sticky-context > .plan-media-actions { margin: 0; flex-wrap: wrap; }
.plan-size-control:not(:disabled):hover,
.plan-size-control:not(:disabled):focus-visible,
.plan-size-control:not(:disabled):active {
  background-color: #164e63 !important;
  border-color: #164e63 !important;
  color: #fff !important;
}
.plan-size-control.btn-primary { background-color: #164e63; color: #fff; }

.plan-draft-table th { background: #164e63; color: white; font-size: 11px; }
.plan-draft-table thead th:nth-child(6) { width: 72px; min-width: 72px; padding-left: 6px; padding-right: 6px; white-space: normal; }
.plan-draft-table td.plan-polish-weight { padding-left: 6px; padding-right: 6px; }
.plan-draft-table td { font-size: 11px; border: 1px solid #d9dee8; }
.plan-draft-table thead th:nth-child(3),
.plan-draft-table td.plan-action-cell { width: 1%; padding-left: 6px; padding-right: 6px; white-space: nowrap; }
.plan-draft-table td.plan-action-cell .btn { padding: 5px 8px; }
.plan-draft-table thead th:nth-child(5),
.plan-draft-table td.plan-purity-cell { width: 64px; padding-left: 6px; padding-right: 6px; }
.plan-draft-table td.plan-purity-cell > span { display: block; max-width: 6ch; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.plan-draft-table button { font-size: 11px; }
.plan-draft-table .plan-shade-light > td { background-color: #fff; }
.plan-draft-table .plan-shade-blue > td { background-color: #f0f7fb; }
.plan-draft-total { background: #e7f0f4; font-weight: 600; }

.plan-summary {
  width: 100%;
  max-width: 520px;
  margin: 24px 0 0 auto;
  padding: 20px;
  border: 1px solid #d9dee8;
  border-radius: 10px;
  background: #f8fafc;
}
.plan-summary-title { margin-bottom: 14px; font-size: 15px; font-weight: 600; color: #164e63; }
.plan-summary-row {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) 150px;
  align-items: center;
  column-gap: 8px;
  row-gap: 12px;
  padding: 6px 0;
  min-height: 42px;
}
.plan-summary-row > label { font-weight: 600; font-size: 13px; }
.plan-summary-row > strong { text-align: right; font-weight: 600; font-variant-numeric: tabular-nums; white-space: nowrap; }
.plan-summary-input { display: flex; align-items: center; gap: 6px; min-width: 0; }
.plan-summary-input input { width: 100%; min-width: 0; min-height: 36px; padding: 6px 10px; background: #fff; }
.plan-summary-input-compact input {
  flex: 0 1 62px;
  width: 62px;
  min-height: 24px;
  height: 24px;
  text-align: center;
  padding: 2px 6px;
}
.plan-summary-row:nth-last-of-type(2) { border-top: 1px solid #d9dee8; margin-top: 8px; padding-top: 12px; color: #164e63; }
.plan-summary-row:last-of-type { margin-top: 8px; }
@media (max-width: 767px) {
  .plan-summary { padding: 14px; }
  .plan-summary-row { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 8px; }
  .plan-summary-row > label { grid-column: 1 / -1; }
  .plan-summary-row > strong { grid-column: 2; }
}

.tender-plan-ui {
  overflow: hidden !important;
  padding-left: 0 !important;
}
.tender-plan-ui :deep(.btn-primary) {
  background-color: #164e63;
  border-color: #164e63;
  color: #fff;
}
.tender-plan-ui :deep(.btn-outline-primary) {
  border-color: #164e63;
  color: #164e63;
}
.tender-plan-ui :deep(.btn-outline-primary:not(:disabled):hover),
.tender-plan-ui :deep(.btn-outline-primary:not(:disabled):focus-visible) {
  background-color: #164e63;
  border-color: #164e63;
  color: #fff;
}
.tender-plan-ui :deep(.modal-header) {
  display: block;
  background: #fff;
  border-bottom: 1px solid #d9dee8;
}
.plan-sticky-context {
  margin-top: 16px;
}
.plan-scroll-footer {
  position: static;
  margin-top: 20px;
  padding-right: 0;
  padding-bottom: 0;
}
.tender-plan-ui :deep(.plan-dialog) {
  width: calc(100vw - 32px) !important;
  max-width: 1600px !important;
  margin: 16px auto !important;
}
.tender-plan-ui :deep(.modal-content) {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  overflow: hidden;
}
.tender-plan-ui :deep(.modal-header),
.tender-plan-ui :deep(.modal-footer) {
  flex-shrink: 0;
}
.tender-plan-ui :deep(.modal-body) {
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}
.plan-top {
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: minmax(140px, 1.4fr) minmax(90px, 0.8fr) repeat(2, minmax(75px, 0.65fr)) minmax(95px, 0.9fr) repeat(3, minmax(80px, 0.7fr)) repeat(2, minmax(110px, 1fr));
  gap: 12px;
}
.plan-field {
  min-width: 0;
}
.plan-field label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
}
.plan-field .form-control,
.plan-field .form-select {
  width: 100%;
  min-height: 38px;
}
.plan-field input[readonly] {
  background: #f3f4f6;
}
.plan-media-actions {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  margin: 16px 0;
}
.plan-lot-options {
  display: flex;
  align-items: center;
  gap: 12px;
}
.plan-lot-options .plan-field {
  display: flex;
  align-items: center;
  gap: 8px;
}
.plan-lot-options label {
  margin: 0;
  white-space: nowrap;
}
.plan-lot-options select {
  width: 160px;
}
.plan-lot-options .plan-field-compact select {
  width: 90px;
}
.plan-media-actions .btn {
  min-height: 30px;
  padding: 4px 9px;
  font-size: 12px;
  line-height: 20px;
}
.plan-media-actions .btn svg {
  width: 16px;
  height: 16px;
}
.plan-media {
  display: flex;
  gap: 16px;
}
.plan-media > div {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.plan-media .btn {
  display: inline-flex;
  align-items: center;
}
.plan-media label {
  display: block;
  text-transform: capitalize;
  font-size: 12px;
}
.plan-entry {
  padding: 16px;
  border: 1px solid #d9dee8;
  border-radius: 6px;
  margin-bottom: 16px;
}
.plan-pricing {
  display: grid;
  grid-template-columns: 109px 118px 120px 117px 157px 180px 172px 93px 235px;
  justify-content: start;
  gap: 10px;
}
.plan-pricing > .plan-field > label {
  min-height: 36px;
  display: flex;
  align-items: flex-end;
  line-height: 18px;
}
.plan-repo-heading {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  min-height: 36px;
  margin-bottom: 6px;
}
.plan-repo-heading > label {
  margin: 0 4px 0 0;
  line-height: 20px;
}
.plan-repo-heading > .btn {
  flex-shrink: 0;
  min-height: 20px;
  padding: 0 5px;
  font-size: 10px;
  line-height: 18px;
}
.plan-field .form-control.plan-repo-rate-input { width: 120px; max-width: 100%; }
.plan-adjacent {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  margin: 16px 0;
}
.plan-adjacent > .plan-field {
  display: grid;
  grid-template-columns: max-content minmax(0, 120px);
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
}
.plan-adjacent > .plan-field > label {
  margin-bottom: 0;
}
.plan-adjacent .form-control { width: 120px; max-width: 100%; }
.plan-pair {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}
.plan-pair-two { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.plan-entry :deep(.parameter-option--active) {
  background: #164e63;
  border-color: #164e63;
  color: white;
}
.plan-additional {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}
.plan-additional > .plan-field {
  flex: 1 1 200px;
}
.plan-additional > .plan-field-compact {
  flex: 0 0 100px;
}
.plan-additional > .plan-field-narrow {
  flex: 0.7 1 140px;
  min-width: 0;
}
.plan-additional > .plan-field-remark {
  flex: 2.5 1 320px;
  min-width: 0;
}
@media (max-width: 1100px) {
  .plan-adjacent { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .plan-top,
  .plan-pricing {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 767px) {
  .plan-top,
  .plan-pricing {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .plan-pair {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .plan-media-actions {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 575px) {
  .plan-adjacent { grid-template-columns: minmax(0, 1fr); }
}


.text-green-800 {
  color: #03543f;
}
.bg-green-100 {
  background-color: #def7ec;
}
.bg-red-100 {
  background-color: #fde8e8;
}
.text-red-800 {
  color: #9b1c1c;
}
.text-yellow-800 {
  color: #723b13;
}
.bg-yellow-100 {
  background-color: #fdf6b2;
}
.text-blue-800 {
  color: #1e429f;
}
.bg-blue-100 {
  background-color: #e1effe;
}
a:link {
  text-decoration: underline;
}
</style>
